const en = {
  common: {
    loading: "Loading...",
    save: "Save",
    saving: "Saving...",
    saved: "Saved",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    send: "Send",
    yes: "Yes",
    no: "No",
    error: "Error",
    success: "Success",
    search: "Search",
    filter: "Filter",
    all: "All",
    more: "More",
    less: "Less",
    or: "or",
    and: "and",
    premium: "Premium",
    basis: "Basic",
    continue: "Continue",
    start: "Start",
    install: "Install",
    upgrade: "Upgrade",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{days} days ago",
  },

  nav: {
    dashboard: "Dashboard",
    tagebuch: "Journal",
    coach: "Coach Sessions",
    sessions: "Sessions",
    hoerbuch: "Audiobook",
    kompass: "Compass",
    community: "Community",
    dokumente: "Documents",
    mikrobiom: "Microbiome",
    ernaehrung: "Nutrition",
    tagesroutine: "Daily Routine",
    rezepte: "Recipes",
    fortschritt: "Progress",
    programme: "Programmes",
    gamification: "Gamification",
    schlaf: "Sleep",
    wearables: "Wearables",
    profil: "Profile",
    hilfe: "Help & FAQ",
    feedback: "Feedback",
    logout: "Log out",
    demo: "Demo",
    willkommen: "Welcome",
    admin: "Admin",
  },

  profil: {
    title: "Profile & Settings",
    meinProfil: "My Profile",
    vorname: "First name",
    nachname: "Last name",
    email: "Email",
    geburtsdatum: "Date of birth",
    speichern: "Save",
    gespeichert: "Saved",
    bearbeiten: "Edit",
    abbrechen: "Cancel",
    paket: "My Package",
    mitgliedSeit: "Member since",
    premiumPaket: "Premium Package",
    basisPaket: "Basic Package",
    stimme: "Choose voice",
    stimmeHinweis: "Choose who accompanies you as a coach and with which voice.",
    sprache: "Language",
    spracheHinweis: "Choose your preferred language for the app.",
    spracheDeutsch: "German",
    spracheEnglisch: "English",
    tutorial: "Tutorial",
    tutorialNeu: "Restart tutorial",
    faq: "Frequently asked questions",
    telegram: "Connect Telegram",
    community: "Community Bot",
    benachrichtigungen: "Notifications",
    abo: "Audio Sessions subscription",
    profilbild: "Profile picture",
    profilbildAendern: "Change profile picture",
    profilbildLoeschen: "Delete profile picture",
    passwortAendern: "Change password",
    kontoLoeschen: "Delete account",
  },

  dashboard: {
    willkommen: "Welcome back, {name}!",
    tageszitat: "Quote of the day",
    fortschritt: "Your progress",
    naechsteSession: "Next session",
    checkin: "Check-in",
    checkinStarten: "Start check-in",
    programme: "Your programmes",
    empfehlungen: "Recommendations",
    heute: "Today",
    tagesroutine: "Daily routine",
    news: "News",
    greeting: "{greeting}, {name}.",
    greetingMorning: "Good morning",
    greetingDay: "Good afternoon",
    greetingEvening: "Good evening",
    greetingNight: "Good night",
    greetingSubtitle: "Great to have you back. How are you today?",
    greetingSubtitleNew: "Welcome to AYU. Let's get started together.",
    phenotyp: "Your Phenotype",
    basedOnQuestionnaire: "Based on your personal questionnaire",
    packagePremium: "AYU + DNA Microbiome",
    packageBasis: "AYU Basic",
    packageDescPremium: "Incl. genetic gut microbiome analysis",
    packageDescBasis: "Personal health plan",
    upgradeBtn: "Upgrade to DNA",
    tagebuchEntries: "Entries",
    tagebuchEntry: "Entry",
    coachSessions: "Sessions",
    coachSession: "Session",
    aktiv: "Days active",
    aktivTag: "Day active",
    coachingStil: "Coaching style",
    deinStil: "Your style",
    stilAendern: "Tap to change",
    tippDesTages: "Tip of the day",
    stimmungsverlauf: "Mood trend",
    stimmungToWenig: "Not enough data",
    stimmungAufwaerts: "Upward",
    stimmungAbwaerts: "Downward",
    stimmungStabil: "Stable",
    stimmungGut: "Good",
    stimmungOkay: "Okay",
    stimmungAusbaufaehig: "Improvable",
    weiterhören: "Continue listening",
    hoerbuchStats: "Audiobook statistics",
    gehoert: "Listened",
    fertig: "Done",
    fortschrittAvg: "Avg progress",
    hoerTage: "Listening days",
    tagebuchWriteEntry: "Write entry",
    tagebuchSubtitle: "Capture your thoughts. Write down what moves you today.",
    coachSubtitle: "Talk to Annam. She knows your story.",
    annamSessions: "Annam Sessions",
    startSession: "Start session",
    kompassTitle: "Compass",
    kompassSubtitle: "Your health overview — recommendations and progress",
    aktivitaet: "Activity",
    checkinFaellig: "Check-in due",
    checkinErster: "First check-in available",
    checkinSubtitle: "Record your current state for personalised recommendations",
    checkinDaysAgo: "Last check-in {days} days ago — time for an update",
    naechsterCheckin: "Next check-in",
    verfuegbarIn: "Available in {days} days — once per quarter",
    pwaInstallTitle: "Install AYU as an app",
    pwaInstallSubtitle: "One tap — AYU directly on your home screen",
    pwaInstallFallback: "Add AYU to your home screen for quick access",
    pwaInstalled: "AYU has been installed!",
    iosStep1: "Tap the Share icon at the bottom of Safari",
    iosStep2: 'Scroll and tap "Add to Home Screen"',
    iosStep3: 'Tap "Add" in the top right — done!',
    iosFinalNote: "AYU will then open full screen, just like a native app.",
    telegramNotConnected: "Not connected yet",
    telegramConnectBtn: "Connect with Annam",
    telegramConnect: "Connect",
    telegramDisconnect: "Cancel",
    telegramSearch: "Search in Telegram for",
    telegramStep1: "Search in Telegram for @Ayu_health_bot",
    telegramStep2: "Send /start",
    telegramStep3: "Enter the code you received here",
    telegramLinked: "Successfully connected!",
    telegramLinkError: "Linking failed",
    telegramConnectionError: "Connection error",
    communityTelegram: "AYU Community — Telegram",
    communityExchange: "Connect with other AYU members",
    communityHowTo: "How to join — 2 simple steps:",
    communityStep1: "Click the button below — it opens the AYU Community Bot directly in Telegram.",
    communityStep2: "Tap START — your account will be linked automatically. Done!",
    communityOpenBot: "Open Community Bot in Telegram",
    communityConfirmJoined: "Already joined? Confirm here",
    communityFallback: "If the link doesn't work: search for @Ayu_community_bot on Telegram",
    upgradeRedirecting: "Redirecting to checkout...",
    upgradeError: "Upgrade error",
    coachSitzungen: "Coach Sessions",
    coachingEmpathisch: "Empathetic",
    coachingDirekt: "Direct",
    coachingFreundschaftlich: "Friendly",
    telegramVerbindeText: "Connect your account with Annam on Telegram for daily check-ins and updates.",
  },

  coach: {
    title: "AYU Coach",
    neueSession: "New session",
    nachricht: "What's on your mind?",
    senden: "Send",
    aufnahme: "Voice recording",
    verlauf: "Conversation history",
    keineSessions: "No sessions yet.",
    sessionStarten: "Start new session",
    sessionBeenden: "End session",
    zusammenfassung: "Summary",
    empfehlungen: "Recommendations",
    archiv: "Archive",
    archivOeffnen: "Open archive",
    archivSchliessen: "Close archive",
    vergangeneSession: "You are viewing a past {type} session.",
    chatSitzung: "chat",
    sprachSitzung: "voice",
    zurueckAktuell: "Back to current session",
    zurueckAktuellerChat: "Back to current chat",
    diesen: "Continue this {type}",
    anrufFortsetzen: "Continue this call",
    chatFortsetzen: "Continue this chat",
    hierWeiterreden: "Continue here",
    hierWeiterchatten: "Chat here to continue.",
    verlaufWirdGeladen: "Loading history...",
    verbindungsproblem: "Connection issue. Please try again.",
    begleiter: "Your personal health companion — by text or voice",
    speakWith: "Speak with {name}",
    voiceStart: "Start real-time voice conversation",
    voice: "Voice:",
    speaking: "Stop reading aloud",
    lastAnswer: "Read last answer aloud",
    readAloud: "Read aloud",
    stop: "Stop",
    loading: "Loading...",
    styleQuestion: "How should I speak with you?",
    coachingStyleSuggestion: "Coaching style suggestion",
    fitForMe: "Suits me",
    later: "Later",
    recordingRunning: "Recording... {duration}s",
    recognizing: "Recognising speech...",
    imageReady: "Image ready to send",
    imageUploaded: "Uploaded image",
    uploadImage: "Upload image",
    speakNow: "Speak now...",
    imageQuestion: "Ask a question about the image...",
    recordingStop: "Stop & transcribe recording",
    startVoice: "Start voice input",
    recordingCancel: "Cancel recording",
    errorImageType: "Please choose an image file (JPG, PNG, WebP, GIF).",
    errorImageSize: "Image too large. Maximum: 10 MB.",
    historyNote: "Annam knows your story and works with you. History is saved.",
    exerciseError: "Exercise could not be started. Please try again.",
    stopRecording: "Stop recording",
    voiceInput: "Voice input",
    archivAusblenden: "Hide archive",
    archivSelectMode: "Select to delete",
    archivSelectSessions: "Select sessions",
    archivNSelected: "{n} selected",
    archivDeleteN: "Delete {n}?",
    archivNoSessions: "No past sessions yet",
    archivRename: "Rename",
    archivContinue: "Continue",
    archivVoiceSession: "Voice session",
    archivSession: "Session",
    archivDeleteWarning1: "This session will be permanently deleted.",
    archivDeleteWarningN: "These sessions will be permanently removed.",
  },

  tagebuch: {
    title: "Journal",
    neuerEintrag: "New entry",
    eintragSchreiben: "What's going through your mind today? Just write — this is your space...",
    datum: "Date",
    stimmung: "Mood",
    energie: "Energy",
    schlaf: "Sleep",
    ernaehrung: "Nutrition",
    bewegung: "Movement",
    notizen: "Notes",
    speichern: "Save entry",
    keineEintraege: "No entries yet.",
    subtitle: "Your space for thoughts, feelings and reflections",
    spruch: "Quote",
    horoskop: "Horoscope",
    witz: "Joke",
    cortisol: "Cortisol reducer of the day",
    sternzeichenUnbekannt: "Your star sign is not yet known.",
    geburtsdatumEingeben: "Enter date of birth",
    uhr: "o'clock",
    wieGefuehlst: "How are you feeling?",
    super: "Great",
    gut: "Good",
    okay: "Okay",
    meh: "Meh",
    schlecht: "Bad",
    eintragGespeichert: "Entry saved",
    eintragGespeichertDesc: "Your journal entry is safely stored. You can leave now — or ask Annam for feedback.",
    deinEintrag: "Your entry",
    coachingBitten: "Ask Annam for coaching",
    annamDenkt: "Annam is thinking...",
    inspiriereicht: "Or get inspired",
    orakel: "Oracle",
    mantra: "Mantra",
    antwortAnnam: "Reply to Annam...",
    keineMeldungen: "No messages in this entry",
    mitAnnamSprechen: "Talk to Annam about this entry",
    laufenderEintrag: "You have an ongoing entry.",
    vorherigTag: "Previous day",
    naechsterTag: "Next day",
    zurueckZuHeute: "Back to Today",
    eintragNum: "Entry {current} of {total}",
    vergangeneEintraege: "{count} past entries",
    aufnahme: "Recording... {duration}s",
    wirdErkannt: "Recognising...",
    aufnehmenStoppen: "Stop recording",
    aufnehmenStarten: "Voice input",
    fehlerGespeichert: "Entry could not be saved. Please try again.",
    fehlerCoaching: "Annam could not respond right now.",
    geburtsdatumTitle: "Your date of birth",
    geburtsdatumDesc: "We need your date of birth for your personal daily horoscope.",
    geburtsdatumLabel: "Date of birth",
    geburtsdatumHinweis: "Your date of birth is only used for the horoscope.",
    wirdGespeichert: "Saving...",
    trigger: "Trigger",
  },

  kompass: {
    title: "AYU Compass",
    subtitle: "Your phenotype profile, daily recommendations and health overview at a glance",
    dosha: "Your Dosha Profile",
    vata: "Vata",
    pitta: "Pitta",
    kapha: "Kapha",
    prakriti: "Prakriti",
    vikriti: "Vikriti",
    beschreibung: "Description",
    empfehlungen: "Recommendations",
    ernaehrung: "Nutrition Recommendations",
    lebensweise: "Lifestyle",
    phenotyp: "Your AYU Phenotype",
    staerken: "Your strengths",
    typgerecht: "Type-specific recommendations",
    bewegung: "Movement",
    mental: "Mental",
    verteilung: "Phenotype distribution",
    mitTendenz: "with tendency towards",
    keinPhenotypTitle: "Your AYU phenotype awaits",
    keinPhenotypDesc: "Complete the AYU questionnaire to discover your personal phenotype and receive individual recommendations for nutrition, movement and mental balance.",
    fragebogenStarten: "Start questionnaire",
    stimmungsverlauf: "Mood trend",
    keineStimmung: "No mood data yet.",
    stimmungHint: "Use the journal to track your mood.",
    aktivitaet: "Your activity",
    coach: "Coach",
    tageDabei: "Days with us",
    hinweis: "The AYU Compass shows you an overview of your health data. The more you use the journal and coach, the more accurate your personal health picture becomes. Your data is used exclusively for your personal health advice.",
  },

  checkin: {
    title: "Daily Check-In",
    stimmung: "How is your mood today?",
    energie: "What is your energy level?",
    schlaf: "How did you sleep?",
    ernaehrung: "How have you been eating?",
    verdauung: "How is your digestion?",
    kommentar: "Additional notes",
    abschicken: "Submit check-in",
    danke: "Thank you for your check-in!",
    gut: "Good",
    mittel: "Okay",
    schlecht: "Poor",
    frage: "Question {current} of {total}",
    weiter: "Next",
    zurueck: "Back",
    abschliessen: "Complete check-in",
    ergebnis: "Your result",
    saveError: "Error saving. Please try again.",
    abgeschlossen: "Check-in completed",
    zustandErfasst: "Your current functional status has been recorded.",
    aktuellerZustand: "Your current status",
    energieLabel: "Energy",
    verdauungLabel: "Digestion",
    schlafLabel: "Sleep",
    stressLabel: "Stress",
    emotionaleBalance: "Emotional balance",
    hautgesundheit: "Skin health",
    immunstaerke: "Immune strength",
    fokusbereich: "Focus area:",
    zumDashboard: "Go to dashboard",
    sessionsStarten: "Start sessions",
    mehrfachauswahl: "Multiple selection possible",
  },

  sessions: {
    title: "Sessions",
    live: "Live conversations",
    uebungen: "Chat exercises",
    verfuegbar: "Available sessions",
    gestartet: "Session started",
    premium: "Premium",
    basis: "Basic",
    unbegrenzt: "Unlimited",
    sessionCount: "Sessions",
    basisKostenlos: "Basic sessions are available free of charge",
    basisSessions: "Basic sessions",
    personalisierteSessions: "Personalised sessions",
    liveGespraeche: "Live conversations",
    chatUebungen: "Chat exercises",
    gespraeche: "Conversations",
    uebungenLabel: "Exercises",
    alleFreischalten: "Unlock all sessions",
    paketeAnsehen: "View packages",
    gratis: "Free",
    genutzt: "Used",
    limitErreicht: "Monthly session limit reached",
    paketUpgraden: "Upgrade package",
    kostenlos: "Free",
    wirdErstellt: "Creating...",
    premiumFreischalten: "Unlock premium",
    starten: "Start",
    sessionBeendet: "Session ended",
    dauer: "Duration:",
    nochmalStarten: "Start again",
    zurueckDashboard: "Back to dashboard",
    sek: "Sec.",
    min: "Min.",
    zahlung: "Payment successful!",
    freigeschaltet: "Sessions unlocked!",
    checkoutAbgebrochen: "Checkout cancelled",
    premiumSessions: "Premium sessions",
    demoModus: "Not available in demo mode",
    beratungBuchen: "Book free consultation",
    schliessen: "Close",
    ayuPremium: "Unlock AYU Premium",
    flexibel: "Flexible & fair",
    wasPassiert: "What is happening?",
    zurück: "Back",
    uebungenSessions: "Exercises & Sessions",
    headerDesc: "Meditation, breathing exercises, Yoga Nidra and more — choose a session to suit your needs",
    basisKostenlosDesc: "With an AYU subscription (Starter, Medium or Unlimited) you get access to all personalised sessions — tailored individually to your AYU phenotype.",
    limitErreichtCount: "Monthly session limit reached ({used}/{limit})",
    limitErreichtDesc: "You have used all your sessions this month. Upgrade your package for more sessions or wait until next month. Basic sessions remain free.",
    liveDesc: "Real conversations with AYU — he listens, responds and accompanies you individually.",
    chatDesc: "Interactive exercises that AYU carries out with you step by step in chat.",
    keineKategorie: "No sessions found in this category.",
    paketeDesc: "Choose a package and get immediate access to all personalised sessions. Every subscription includes all exercises — no hidden costs.",
    zahlungDesc: "Your access will be activated in a few seconds...",
    freigeschaltetDesc: "You can now use all personalised sessions.",
    checkoutAbgebrochenDesc: "You can choose a package again at any time.",
    bitteMelden: "Please log in first.",
    weiterleitungStripe: "Redirecting to Stripe...",
    checkoutFehler: "Checkout error",
    sessionGestartetDesc: "The guided session is starting...",
    sessionLimitErreicht: "Session limit reached",
    limitUpgradeDesc: "Upgrade your package or wait until next month. Basic sessions remain free.",
    gratisGenutzt: "Free session already used",
    gratisGenutztDesc: "Unlock a subscription to use this session again.",
    sessionBereit: "Session ready!",
    sessionBereitDesc: "Your personalised session is now playing.",
    personalisiertePremium: "Personalised premium session",
    fehlerErstellung: "Error creating session",
    phaseChecking: "Checking session...",
    phaseText: "Generating text...",
    phaseAudio: "Generating audio...",
    phaseFertig: "Session is ready!",
    phaseFehler: "Error",
    phaseCheckingDesc: "We are checking whether your session is already available.",
    phaseTextDesc: "The personalised text is being created for you.",
    phaseAudioDesc: "The text is being converted into a professional voice recording.",
    phaseFertigDesc: "Your session is now playing...",
    wasPassiertText: "AYU is creating a personalised {title} session just for you. The text is generated by AI and then converted into a professional audio guide. This process usually takes 30–60 seconds.",
    approxTime: "approx. 30–60 sec.",
    demoBody: "In demo mode you can view the sessions. For full access, book a free consultation.",
    ayuPremiumDesc: "Get access to all personalised sessions — tailored individually to your AYU phenotype.",
    beliebt: "Popular",
    starterWaehlen: "Choose Starter",
    mediumWaehlen: "Choose Medium",
    unlimitedWaehlen: "Choose Unlimited",
    flexibelDesc: "Cancel or downgrade at any time. You can adjust your package monthly — no minimum term, no hidden costs.",
    stepText: "Text",
    stepAudio: "Audio",
    stepFertig: "Done",
    katAlle: "All",
    katBasis: "Basic",
    katAtem: "Breathing",
    katEntspannung: "Relaxation",
    katMeditation: "Meditation",
    katEnergetisch: "Energetic",
    katIntensiv: "Intensive",
  },

  programme: {
    title: "Programmes",
    aktuell: "Current Programme",
    abgeschlossen: "Completed Programmes",
    verfuegbar: "Available Programmes",
    starten: "Start programme",
    fortsetzen: "Continue",
    woche: "Week",
    lektion: "Lesson",
    abgeschlossenAm: "Completed on",
    katalog: "Programme catalogue",
    katalogSubtitle: "Learn step by step in weekly modules — from nutrition to stress management",
    wochen: "{n} weeks",
    aufgaben: "{n} tasks",
    wocheVon: "Week {current} of {total}",
    aktiv: "Active",
    dna: "DNA",
    abgeschlossenBadge: "Completed",
    upgradeLink: "Upgrade to AYU + DNA",
    jetztKaufen: "Buy now for {price} €",
    kostenlosBeiUpgrade: "Free when upgrading to AYU + DNA",
    weiterMachen: "Continue",
    detailsAnsehen: "View details",
    keineProgramme: "No programmes available",
    keineProgrammeDesc: "New programmes will be added soon.",
    zurueckKatalog: "Back to catalogue",
    aufgabenVon: "{completed} of {total} tasks",
    jetzEinschreiben: "Enrol now",
    pausieren: "Pause",
    fortsetzenBtn: "Continue",
    wochenplan: "Weekly plan",
    aktuelleWoche: "Current week",
    lernziele: "Learning goals this week",
    audio: "Audio:",
    rezept: "Recipe:",
    bonus: "Complete this programme and receive {points} Prana points!",
    programmAbgeschlossen: "Programme completed!",
    glueckwunsch: "Congratulations! You have completed all tasks.",
    aufgabeErledigt: "Task done!",
    fortschrittLabel: "Progress: {percent}%",
    speichernFehler: "Error saving",
    eingeschrieben: "You are now enrolled!",
    eingeschriebenDesc: "Your programme starts today. Good luck!",
    einschreibungFehler: "Enrolment failed",
    eingeschriebenJetzt: "Enrolled! Your programme starts now.",
    programmFortgesetzt: "Programme resumed!",
    programmPausiert: "Programme paused. You can continue any time.",
    programmAbgebrochen: "Programme cancelled.",
    programmNichtGefunden: "Programme not found.",
    checkoutRedirecting: "You are being redirected to checkout...",
    checkoutFehler: "Error creating checkout session",
    minLabel: "min.",
    aktualisierungFehler: "Error updating",
  },

  rezepte: {
    title: "Your recipes",
    suche: "Search recipes...",
    kategorien: "Categories",
    favoriten: "Favourites",
    alle: "All recipes",
    fruehstueck: "Breakfast",
    mittagessen: "Lunch",
    abendessen: "Dinner",
    snack: "Snack",
    getraenk: "Drink",
    zutaten: "Ingredients",
    zubereitung: "Preparation",
    portionen: "Servings",
    dauer: "Duration",
    speichern: "Save recipe",
    gespeichert: "Saved",
    subtitle: "Discover Ayurvedic dishes suited to your constitution",
    sammlungen: "Collections",
    neueSammlung: "New collection",
    sammlungErstellt: "Collection created!",
    sammlungUmbenannt: "Collection renamed!",
    sammlungGeloescht: "Collection deleted",
    sammlung: "Add to collection",
    teilen: "Share in community",
    pdfDrucken: "Print as PDF",
    loeschen: "Delete",
    bearbeiten: "Edit recipe",
    ayurvHinweis: "Ayurvedic note",
    rezeptAnzeigen: "Show recipe →",
    rezeptGenerieren: "Generate recipe",
    eigenesRezept: "Own recipe",
    eigenesRezeptDesc: "Add your favourite recipe manually",
    hinzufuegen: "Add",
    rezeptAusФoto: "Recipe from photo",
    rezeptWirdErkannt: "Recipe being recognised...",
    fotoAuswaehlen: "Select photo",
    eigenesHinzufuegen: "Add own recipe",
    neuesRezeptErstellt: "New recipe created!",
    rezeptGespeichert: "\"{title}\" has been saved!",
    rezeptFotoImport: "\"{title}\" was imported from the photo!",
    rezeptAktualisiert: "Recipe updated!",
    rezeptGeloescht: "Recipe deleted",
    rezeptGeteilt: "Recipe shared in the community!",
    fehlerTeilen: "Error sharing: {msg}",
    fehlerBildLesen: "Error reading image.",
    bildTypFehler: "Please select an image (JPG, PNG or WebP).",
    bildZuGross: "Image too large (max. 10 MB).",
    titelEingeben: "Please enter a title.",
    nochKeinRezept: "No recipes yet.",
    nochKeinRezeptCollection: "No recipes in \"{name}\" yet. Add recipes via the three-dot menu.",
    nochKeinFavoriten: "No favourites yet. Click the heart icon to mark recipes.",
    nochKeinNachricht: "No collections created yet",
    titel: "Title",
    kurzbeschreibung: "Short description",
    kategorie: "Category",
    zubereitungszeit: "Preparation time",
    notizHinweis: "Note / hint",
    min: "min",
    speichernBtn: "Save",
    aenderungenSpeichern: "Save changes",
    wirdGespeichert: "Saving...",
    wirdErstellt: "Creating...",
    generieren: "Generate",
    abbrechen: "Cancel",
    wuensche: "Preferences? e.g. 'no dairy', 'quick'...",
    sammlungLoeschenBestaetigung: "Are you sure you want to delete this collection?",
    sammelnNamePlaceholder: "Collection name...",
    erstellen: "Create",
    teilenKurz: "Share",
    fotoDesc: "Photograph a recipe from a cookbook, magazine or handwritten notes.",
    nochKeinRezeptHauptseite: "No recipes yet. Generate, create or import your first recipe!",
    rezeptSingular: "recipe",
    rezeptPlural: "recipes",
    vonAnzahl: "of {total}",
    eineProZeile: "(one per line)",
    einSchritt: "(one step per line)",
    alle_label: "All",
  },

  fortschritt: {
    title: "Your progress",
    uebersicht: "Overview",
    woche: "This week",
    monat: "This month",
    gesamt: "Total",
    subtitle: "Track your habits, goals and personal development",
    deineSerien: "Your streaks",
    deineZiele: "Your goals",
    neuesZiel: "New goal",
    neuesZielErstellen: "Create new goal",
    schnellstart: "Quick-start templates:",
    eigenesZiel: "Or own goal:",
    zielTitel: "Goal title...",
    tageLabel: "Days",
    zielErstellen: "Create goal",
    pausiert: "Paused",
    erreicht: "Achieved ({n})",
    heuteAktiv: "Active today",
    rekord: "Record:",
    gesamtLabel: "Total:",
    tage: "days",
    zielErreicht: "Goal achieved!",
    heuteErledigt: "Done today",
    heuteAbhaken: "Check off today",
    fortsetzen: "Continue",
    neuesZielErstellt: "New goal created!",
    herzlichen: "Congratulations! Goal completed.",
    fortschrittGespeichert: "Progress saved!",
    zielGeloescht: "Goal deleted",
    keinZielBeschreibung: "Create your first goal to track your progress.",
    ayuPfadWie: "How does the AYU path work?",
    ayuPfadErklärung: "Prana points, streaks, badges & levels explained",
    nochKeineSerien: "No streaks yet. Use the journal, coach or sessions to start your first streak!",
    ersteZielErstellen: "Create first goal",
    allesBadgesLevel: "View all badges & level details",
  },

  gamification: {
    title: "Your AYU path",
    punkte: "Prana points",
    abzeichen: "Badges",
    level: "Level",
    streak: "Streak",
    naechstesBadge: "Next badge",
    subtitle: "Your personal health journey — points, badges & progress",
    uebersicht: "Overview",
    verlauf: "History",
    challenges: "Challenges",
    zuNaechstemLevel: "% to next level",
    prana: "Prana",
    score: "Score",
    badges: "Badges",
    soFunktioniert: "How your AYU path works",
    verdienteAbzeichen: "Earned badges ({n})",
    alleAbzeichen: "All badges",
    verdient: "Earned",
    aktivesChallenges: "Active challenges",
    vergangenesChallenges: "Past challenges",
    erledigt: "done",
    erledigtLabel: "Done",
    abgelaufen: "Expired",
    pranaVerlauf: "Prana points history",
    ayuScoreVerlauf: "AYU score history",
    aktuell: "Current",
    tagebuchEintrag: "Journal entry:",
    coachSitzung: "Coach session:",
    tagesroutineLabel: "Daily routine:",
    meditation: "Meditation:",
    rezeptGekocht: "Recipe cooked:",
    communityBeitrag: "Community contribution:",
    nochKeinePunkte: "No points collected yet",
    nochKeinePunkteDesc: "Start with a journal entry or a coach session!",
    ayuPfad7Level: "AYU Path (7 Levels)",
  },

  schlaf: {
    title: "Sleep tracker",
    tracking: "Sleep tracking",
    analyse: "Sleep analysis",
    empfehlungen: "Sleep recommendations",
    subtitle: "Record and analyse your sleep — your sleep pattern feeds directly into coaching",
    eintragsFormular: "Entry",
    eintragsBearbeiten: "Edit entry",
    neuerEintrag: "New entry",
    vorhandenHinweis: "You already have an entry for this day. You can update it.",
    wieGeschlafen: "How did you sleep?",
    datum: "Date",
    eingeschlafen: "Fell asleep",
    aufgewacht: "Woke up",
    wieErholt: "How rested do you feel?",
    einschlafen: "Falling asleep",
    nachtsAufgewacht: "Night wake-ups",
    traeumeErinnert: "Dreams remembered",
    notizen: "Notes (optional)",
    notizenPlaceholder: "e.g. caffeine in the evening, stress, exercise...",
    aktualisieren: "Update",
    speichern: "Save",
    letzte14: "Last 14 days",
    avQualitaet: "Avg. quality",
    avSchlafdauer: "Avg. duration",
    eintraege: "Entries",
    zuWenigDaten: "Not enough data",
    qualitaetsverlauf: "Quality history",
    besteNacht: "Best night",
    schlechtesteNacht: "Worst night",
    coachingEinfliessen: "Your sleep feeds into coaching",
    coachingEinfliessenDesc: "Annam considers your sleep data in coaching sessions and can give you personalised recommendations for better sleep.",
    wearableIntegration: "Wearable integration",
    wearableDesc: "Connect your wearable for automatic sleep tracking with HRV, deep sleep phases and more.",
    demnächst: "Coming soon",
    letzteEintraege: "Recent entries",
    eintraegLoeschen: "Delete entry",
    eintraegAktualisiert: "Entry updated",
    schlafEintragGespeichert: "Sleep entry saved",
    eintraegGeloescht: "Entry deleted",
    bitteMeldeAn: "Please log in.",
    sofort: "Immediately",
    schnell: "Quickly",
    normal: "Normal",
    schwer: "Difficult",
    sehrSchwer: "Very difficult",
    sehrSchlecht: "Very poor",
    schlecht: "Poor",
    okay: "Okay",
    gut: "Good",
    sehrGut: "Very good",
    erschoepft: "Exhausted",
    muede: "Tired",
    erholt: "Rested",
    vollerEnergie: "Full of energy",
  },

  wearables: {
    title: "Wearables",
    verbinden: "Connect device",
    daten: "Health data",
    sync: "Synchronise",
    subtitle: "Connect your wearable with Annam for automatic tracking and personalised coaching based on your biometric data.",
    baldVerfuegbar: "Coming soon",
    integrationen: "Wearable integrations coming soon",
    integrationenDesc: "We are working on seamless integrations with the most popular health wearables. Your sleep, stress and HRV data will automatically feed into your AYU coaching — for even more precise and personalised recommendations.",
    warteliste: "On the waitlist",
    benachrichtige: "Notify me",
    wartelisteN: "You are on {n} waitlist.",
    wartelistenN: "You are on {n} waitlists.",
    soFunktioniert: "How it will work",
    step1Title: "Connect",
    step1Desc: "Connect your wearable with one click via the official API.",
    step2Title: "Synchronise",
    step2Desc: "Sleep, HRV and stress data are transferred automatically and securely.",
    step3Title: "Personalise",
    step3Desc: "Annam uses your biometric data for even more accurate recommendations.",
    datenschutz: "Your health data is transmitted encrypted and used exclusively for your personal coaching. You can disconnect at any time.",
    bereitsWarteliste: "You are already on the waitlist!",
    benachrichtigtBald: "You will be notified when the integration is available!",
    fehlerEintragen: "Error signing up. Please try again.",
    fehlerAustragen: "Error removing. Please try again.",
    entfernt: "You have been removed from the waitlist.",
    ayuIntegration: "AYU integration",
    datenFliessen: "Data flows automatically into your AYU coaching.",
  },

  tagesroutine: {
    title: "Daily Routine",
    morgen: "Morning routine",
    abend: "Evening routine",
    aufgaben: "Tasks",
    mittag: "Midday routine",
    schritte: "Steps",
    startzeiten: "Adjust start times",
    startzeitenHinweis: "Adjust the start times to your daily rhythm — e.g. for night shifts or late risers",
    zuruecksetzen: "Reset",
    morgenLabel: "Morning",
    mittagLabel: "Midday",
    abendLabel: "Evening",
    uhr: "o'clock",
    kraeuterEmpfehlungen: "Herb recommendations",
    dosierung: "Dosage:",
    neuGenerieren: "Generate new routine",
    wirdAktualisiert: "Updating...",
    erstelltAm: "Created on {date}",
    keinePlan: "No daily routine created yet",
    keinePlanDesc: "Get a personalised daily routine created for you — based on your phenotype, health data and the current season.",
    erstellen: "Create daily routine",
    wirdErstellt: "Creating...",
    routineErstellt: "Your new daily routine has been created!",
    erstellenFehler: "Error creating: {msg}",
    zeitZurueckgesetzt: "Times reset to default",
    wieRoutine: "How do you like your routine?",
    routineLabel: "{season} routine",
  },

  hoerbuch: {
    title: "Audiobook",
    kapitel: "Chapter",
    abspielen: "Play",
    pausieren: "Pause",
    fortschritt: "Progress",
    weiterhören: "Continue listening",
    abgeschlossen: "Completed",
    gratis: "Free",
    aktiv: "Active",
    gehoert: "listened",
    gehoertLabel: "Listened",
    freischalten: "Unlock full audiobook",
    jetztKaufen: "Buy now",
    sofortVerfuegbar: "Immediately available",
    dauerhafterZugang: "Permanent access",
    professionell: "Professionally narrated",
    einmaligerKauf: "One-time purchase",
    offlineModus: "Offline mode",
    alleOffline: "All chapters available offline",
    kapitelGespeichert: "{n} of {m} chapters saved",
    loeschen: "Delete",
    alleHerunterladen: "Download all",
    laedt: "Loading...",
    kapitelWerdenGespeichert: "Chapters are being saved for offline use...",
    premiumZugang: "Premium access",
    freigeschaltet: "Unlocked",
    lesezeichen: "Bookmarks",
    notizen: "Notes",
    kiSummary: "AI summary",
    statistik: "Statistics",
    export: "Export",
    sleep: "Sleep",
    timerAbbrechen: "Cancel timer",
    minuten: "{n} minutes",
    deineLesezeichen: "Your bookmarks",
    deineNotizen: "Your notes",
    notizEingeben: "Enter note...",
    speichern: "Save",
    keineNotizen: "No notes yet...",
    kiZusammenfassung: "AI summary",
    kernpunkte: "Key points",
    kiHinweis: "Get an AI summary of the chapter",
    zusammenfassungGenerieren: "Generate summary",
    wirdErstellt: "Creating...",
    hoerbuchStatistiken: "Your audiobook statistics",
    avFortschritt: "Avg. progress",
    hoerTage: "Listening days",
    meistGehoert: "Most listened:",
    kapitelLabel: "Chapter",
    nKapitel: "{n} chapters",
    nVonMGratis: "{n} of {m} free",
    wenigerAnzeigen: "Show less",
    alleKapitelAnzeigen: "Show all {n} chapters",
    allesBereitsCached: "All chapters are already available offline.",
    kapitelWerdenGeladen: "Downloading {n} chapters...",
    cacheClearedToast: "Offline cache cleared.",
    sleepTimerAbgelaufen: "Sleep timer expired — playback paused.",
    sleepTimerGesetzt: "Sleep timer: {n} minutes",
    zusammenfassungErstellt: "Summary created",
    zusammenfassungFehler: "Error creating summary",
    nochKeineExportDaten: "No notes, bookmarks, or summaries to export yet.",
    notizenExportiert: "Notes exported!",
    lesezeichenGespeichert: "Bookmark saved",
    lesezeichenGeloescht: "Bookmark deleted",
    notizGespeichert: "Note saved",
    notizAktualisiert: "Note updated",
    notizGeloescht: "Note deleted",
    weiterleitungKasse: "You are being redirected to checkout...",
    checkoutFehler: "Error creating checkout session",
    bitteMelden: "Please log in first.",
    erfolgreichGekauft: "Audiobook purchased successfully! All chapters are now unlocked.",
    kaufAbgebrochen: "Purchase cancelled.",
    nurVollversion: "This chapter is only available in the full version.",
    vollversionBeschreibung: "Purchase the audiobook for €9.90 to unlock all chapters.",
    kaufenAction: "Buy",
    purchaseDesc: "All {n} chapters — over {total} minutes of knowledge about Ayurveda, genetics and your personal health journey.",
    buchMeta: "By Annam & Christopher Hanfstein · {n} chapters · ~{total} minutes",
    ueberBuch: "About the Book",
    ueberBuchDesc: "Discover how the millennial wisdom of Ayurveda merges with modern genetics and epigenetics into a revolutionary health approach. Annam and Christopher Hanfstein show you why a personalised path is the key to sustainable health.",
    keineNotizenHinweis: "No notes yet. Start playback and write down your thoughts.",
    summariesVon: "{n} of {m} chapters summarised",
    nochKeineStatistiken: "No statistics yet. Start a chapter to see your listening statistics.",
    kapitelPausieren: "Pause {title}",
    kapitelAbspielen: "Play {title}",
    featureProfessionell: "Professional",
    featureProfessionellDesc: "AI voice in studio quality",
    featureKapitelDesc: "Over {total} min of content",
    featureDauerhaft: "Permanent",
    featureDauerhaftDesc: "Buy once, listen forever",
    offlineVerfuegbar: "Available offline",
    lesezeichenLoeschen: "Delete bookmark",
    bearbeiten: "Edit",
  },

  community: {
    title: "Community",
    nachrichten: "Messages",
    kanal: "Channel",
    senden: "Send",
    keineNachrichten: "No messages yet",
    nachrichtLoeschen: "Delete message?",
    unwiderruflich: "This message will be permanently deleted.",
    abbrechen: "Cancel",
    loeschen: "Delete",
    telegramBeitreten: "Join Telegram community",
    communityBotOeffnen: "Open community bot",
    telegramVerbunden: "Telegram connected",
    botOeffnen: "Open bot",
    ersteNachricht: "Be the first to write",
    neueNachricht: "1 new message",
    neueNachrichten: "{n} new messages",
    bildBereit: "Image ready to send",
    beschreibung: "Description...",
    schreibEtwas: "Write something...",
    respektvoll: "Be respectful and supportive.",
    bearbeiten: "Edit",
    loeschenAdmin: "Delete (Admin)",
    subtitle: "Connect with the AYU community",
  },

  dokumente: {
    title: "My documents",
    hochladen: "Upload document",
    keineDoc: "No documents uploaded yet.",
    analysieren: "Analyse",
    subtitle: "Upload therapy reports, lab results and other health documents",
    typWaehlen: "Choose document type",
    hierziehen: "Drag file here or click",
    formate: "PDF, TXT, JPG, PNG, DOCX — max. 10 MB",
    wirdHochgeladen: "Uploading and analysing...",
    hochgeladeneLabel: "Uploaded documents ({n})",
    keineDocHilfe: "Your documents help AYU understand you better",
    typNichtUnterstuetzt: "File type not supported. Please use PDF, TXT, JPG, PNG or DOCX.",
    zuGross: "File too large. Maximum: 10 MB.",
    wirdAnalysiert: "Being analysed...",
    analyseFehler: "Analysis failed — document was saved anyway.",
    loeschenAria: "Delete document",
    gesundheitsbericht: "Health report",
    laborbefund: "Lab result",
    ernaehrungsplan: "Nutrition plan",
    rezept: "Prescription",
    sonstiges: "Other",
    uploadFehler: "Upload failed",
    subtitleCoaching: "Upload therapy reports, doctor's letters or lab results — AYU uses them for personalised coaching.",
  },

  mikrobiom: {
    title: "Microbiome analysis",
    analyse: "Microbiome analysis",
    ergebnisse: "Results",
    empfehlungen: "Recommendations",
    premium: "Premium feature",
    subtitle: "Your personal gut microbiome analysis — analysed by Annam and aligned with your phenotype.",
    nurDNA: "Only available in the DNA package",
    nurDNADesc: "The microbiome analysis is an exclusive feature of the AYU + DNA Microbiome package. Our team creates your personal AI-powered analysis that refines your phenotype even more precisely.",
    dasErwartet: "What to expect",
    upgradeBtn: "Upgrade to AYU + DNA Microbiome",
    upgradePreis: "Upgrade for just €500 — the difference from your existing package.",
    wartenLaborergebnisse: "Waiting for your lab results",
    wartenDesc: "Once your microbiome test report has arrived from the lab, our team will create the analysis and make it available here for you. You will be notified once your analysis is ready.",
    analyseAbgeschlossen: "Analysis completed",
    deineAuswertung: "Your microbiome analysis",
    ganzeBesprechen: "Discuss full analysis with AYU coach",
    befundeBesprechen: "Discuss findings with AYU coach",
    empfehlungenBesprechen: "Discuss recommendations with AYU coach",
    phenotypBesprechen: "Discuss phenotype relevance with AYU coach",
    besprechen: "Discuss",
    wichtigsteBefunde: "Key findings",
    empfehlungenFuer: "Recommendations for you",
    phenotypRelevanz: "Phenotype relevance",
    phenotypRelevanzMikrobiom: "Phenotype relevance from microbiome",
    detaillierteAnalyse: "Detailed analysis",
    extrahierteDaten: "Extracted data",
    phenotypVerfeinern: "Refine my phenotype with microbiome data",
    phenotypWirdVerfeinert: "Refining phenotype...",
    phenotypVerfeinertErfolgreich: "Your phenotype has been successfully refined!",
    phenotypVerfeinertDesc: "The microbiome data now flows into your profile. Check the dashboard for your updated result.",
    naechstesMikrobiom: "Recommendation: Next microbiome",
    mikrobiomFaellig: "Recommendation: New microbiome due",
    analyseErstellt: "Analysis created on {date}",
    datenquellen: "Based on {n} data sources",
    upgradeRedirecting: "You are being redirected to checkout...",
    upgradeFehler: "Error upgrading",
    lockedBullet1: "AI analysis of your microbiome report",
    lockedBullet2: "Phenotype refinement with microbiome data",
    lockedBullet3: "Personalised nutrition recommendations",
    lockedBullet4: "1,900+ microbiome positions analysed",
    anbieter: "Provider: {value}",
    unbekannt: "Not recognised",
    diversitaet: "Diversity: {n}/100",
    statusGut: "Good",
    statusAuffaellig: "Abnormal",
    statusKritisch: "Critical",
    phenotypVerfeinertToast: "Phenotype refined: {from} → {to}",
    phenotypBestaetigt: "Phenotype confirmed: {name}",
    verfeinernFehler: "Refinement failed",
    seitEmpfohlen: "Recommended since {date} — please have a new test done.",
    abEmpfohlen: "Recommended from {date} for optimal monitoring.",
    diversitaetsindex: "Diversity index",
    schluesselBakterien: "Key bacteria",
    entzuendungsmarker: "Inflammation markers",
    kurzkettFettsaeuren: "Short-chain fatty acids",
    auffaelligkeiten: "Abnormalities",
  },

  ernaehrung: {
    title: "Nutrition profile",
    profil: "My nutrition profile",
    praeferenzen: "Dietary preferences",
    allergien: "Allergies & intolerances",
    speichern: "Save profile",
    subtitle: "Record preferences, intolerances and eating habits — your coach will adapt recommendations and recipes accordingly",
    vonAngaben: "{filled} of {total} fields filled in",
    vollstaendig: "Complete! Your coach now has a detailed nutritional picture.",
    lebensmittelPraeferenzen: "Food preferences",
    bewerteLebensmittel: "Rate each food: Do you like it (Yes), dislike it (No), or are you indifferent (Neutral)?",
    ernaehrungsfrequenz: "Eating frequency",
    wieOft: "How often do you eat the following food groups per week?",
    ja: "Yes",
    nein: "No",
    neutral: "Neutral",
    taeglich: "Daily",
    dreiBisSechsmal: "3–6x per week",
    einsBisZweimal: "1–2x per week",
    nie: "Never / almost never",
    gespeichert: "Nutrition profile saved",
    gespeichertDesc: "Your food preferences have been updated.",
    fehlerSpeichern: "Error saving",
    profilSpeichern: "Save nutrition profile",
  },

  dinacharya: {
    title: "Your daily routine",
    morgen: "Morning routine",
    abend: "Evening routine",
    empfehlungen: "Recommended activities",
    mittag: "Midday routine",
    subtitle: "Dinacharya — tick off morning, midday and evening routines and build healthy habits",
    schritte: "{n} steps",
    startzeiten: "Adjust start times",
    startzeitenHinweis: "Adjust the start times to your daily rhythm — e.g. for night shifts or late risers",
    zuruecksetzen: "Reset",
    morgenLabel: "Morning",
    mittagLabel: "Midday",
    abendLabel: "Evening",
    uhr: "o'clock",
    keinePlan: "No daily routine created yet",
    keinePlanDesc: "Get a personalised daily routine created for you — based on your phenotype, health data and the current season.",
    erstellen: "Create daily routine",
    wirdErstellt: "Creating...",
    kraeuterEmpfehlungen: "Herb recommendations",
    wieRoutine: "How do you like your routine?",
    neuGenerieren: "Generate new routine",
    wirdAktualisiert: "Updating...",
    erstelltAm: "Created on {date}",
    routineErstellt: "Your new daily routine has been created!",
    erstellenFehler: "Error creating: {msg}",
    zeitZurueckgesetzt: "Times reset to default",
    zeitGeaendert: "{label} now starts at {time}",
    routineLabel: "{season} routine",
    dosierung: "Dosage:",
  },

  onboarding: {
    title: "Welcome to AYU",
    subtitle: "Let us create your personal health plan together.",
    weiter: "Next",
    zurueck: "Back",
    abschliessen: "Complete",
    frage: "Question {current} of {total}",
    fortschritt: "Progress",
    auswerten: "Evaluate",
    laden: "Loading...",
    deinPhenotyp: "Your AYU phenotype",
    basiertAufAntworten: "Based on your answers we have determined your personal health type.",
    konfidenz: "Confidence",
    hoch: "High",
    mittel: "Medium",
    niedrig: "Low",
    topPhenotypen: "Top phenotypes",
    zweiInEins: "2-in-1 phenotype:",
    zeigstMerkmale: "You also show strong characteristics of the",
    mehrfachauswahl: "Multiple selection possible",
    deinAntwort: "Your answer...",
    bitterGenauer: "Please describe more precisely...",
    niedrigLabel: "Low",
    hochLabel: "High",
    telegramVerbinden: "Connect Telegram",
    telegramOptional: "Connect with Telegram for daily check-ins and community exchange.",
    optional: "(Optional)",
    annamOeffnen: "Open Annam",
    telegramHinweis: "Opens Telegram → Tap START → Enter the code in the app under Profile",
    communityBeitreten: "Join community",
    communityHinweis: "Opens Telegram → Tap START → Account is automatically linked",
    dashboardOeffnen: "Open my AYU dashboard",
    ueberspringen: "Skip — connect later",
    pwaTitle: "AYU on your home screen",
    pwaSubtitle: "Access AYU quickly at any time — like a real app.",
    sofortzugriff: "Instant access",
    sofortzugriffDesc: "One tap on the home screen — straight into AYU",
    vollbild: "Full-screen experience",
    vollbildDesc: "Without the browser bar — looks like a real app",
    keinDownload: "No download needed",
    keinDownloadDesc: "No App Store, no storage space — ready immediately",
    iosAnleitung: "How to on iPhone:",
    iosSchritt1: "Tap the share icon at the bottom of Safari",
    iosSchritt2: 'Scroll and tap "Add to Home Screen"',
    iosSchritt3: 'Tap "Add" in the top right — done!',
    iosGemacht: "Follow the steps above!",
    appInstalliert: "AYU has been installed!",
    verstanden: "Got it, I've done it!",
    appInstallieren: "Install AYU app",
    soGehtEs: "How to:",
    browserMenue: "Open the browser menu (⋮ top right)",
    startbildschirm: 'Tap "Add to home screen"',
    ueberspringenSpaeter: "Skip — install later",
    ja: "Yes",
    nein: "No",
    neutral: "Neutral",
    von: "From",
    bis: "To",
    secondaryMerkmale: "You also show strong traits of \"{name}\" ({system}).",
  },

  auth: {
    anmelden: "Log in",
    abmelden: "Log out",
    registrieren: "Register",
    email: "Email",
    passwort: "Password",
    passwortVergessen: "Forgot password?",
    anmeldenBtn: "Log in now",
    willkommen: "Welcome to AYU",
    loginFehler: "Login failed",
    abmeldenBestaetigen: "Are you sure you want to log out?",
    willkommenZurueck: "Welcome back",
    kontoErstellen: "Create account",
    passwortZuruecksetzen: "Reset password",
    neuesPasswort: "Choose new password",
    loginSubtitle: "Log in to see your personal health plan",
    registerSubtitle: "Create your AYU account for personalised health",
    forgotSubtitle: "Enter your email to reset your password",
    resetSubtitle: "Choose a new password for your AYU account",
    vorname: "First name",
    nachname: "Last name",
    passwortMinLength: "At least 8 characters",
    linkSenden: "Send link",
    passwortAendern: "Change password",
    zurueckZumLogin: "Back to login",
    bereitsKonto: "Already have an account? Log in",
    nochKeinKonto: "No account yet? Register now",
    neuBeiAyu: "New to AYU?",
    kontoErstellenHint: "Create your free account in 30 seconds and start your personal health plan.",
    jetzt: "Create account now",
    wasErwartet: "What to expect after signing up",
    soGehtEs: "Here's what happens next:",
    schritt1: "Short questionnaire — so Annam gets to know you",
    schritt2: "Your dashboard is set up",
    schritt3: "Start your first conversation with Annam",
    datensicherheit: "Your data is secure. We use encryption and store passwords only as hashes.",
    ungueltig: "Invalid email or password",
    passwortZuKurz: "Password must be at least 8 characters",
    registrierungFehler: "Registration failed. Is the email already taken?",
    resetLinkGesendet: "If an account with this email exists, you will receive a reset link.",
    passwortGeaendert: "Your password has been changed successfully. You can now log in.",
    linkUngueltig: "This link is invalid or has expired.",
    neuesPasswortLabel: "New password",
    platzhalterEmail: "your@email.com",
    annamTitle: "Annam",
    annamDesc: "Your personal AI coach who knows your story and accompanies you.",
    sprachCoach: "Voice coach",
    sprachCoachDesc: "Talk to Annam in real time — like a conversation with a good friend.",
    tagebuchFeature: "Journal",
    tagebuchFeatureDesc: "Record your thoughts, feelings and progress — privately and securely.",
    communityFeature: "Community",
    communityFeatureDesc: "Connect with others on a similar journey.",
  },

  hilfe: {
    title: "Help & Support",
    subtitle: "Questions about AYU? Ask the AI assistant or browse frequently asked questions — we're happy to help",
    chatTab: "Chat",
    faqTab: "FAQ",
    kontaktTab: "Contact",
    soNutzt: "How to get the most from AYU",
    kontaktTitle: "Contact us",
    kontaktSubtitle: "Our support team is happy to help with any questions.",
    emailLabel: "Email",
    telefonLabel: "Phone",
    telefonZeiten: "Mon–Fri, 9am–5pm",
    schnelleHilfe: "Quick help",
    schnelleHilfeDesc: "Use the chat assistant for instant answers to most questions.",
    zumChat: "Go to chat assistant",
    akuteKrise: "Acute crisis?",
    step1Title: "Use the diary daily",
    step1Desc: "Even 5 minutes is enough. Regularity is more important than length.",
    step2Title: "Annam for deeper topics",
    step2Desc: "If you really want to work through a topic, use Annam.",
    step3Title: "Be honest with yourself",
    step3Desc: "Annam works best when you are open. Everything stays confidential.",
    faqWieStarten: "How do I get started with Annam?",
    faqWieStartenAntwort: "After registration, you complete the onboarding questionnaire (approx. 15 minutes). Based on your answers, your personal AYU phenotype is determined and your individual health plan is created.",
    faqPhenotyp: "What is my AYU phenotype?",
    faqPhenotypAntwort: "AYU works with 12 human phenotypes in 5 clusters. Your phenotype describes your individual physical and mental constitution. You can find your result in the Compass section of the app.",
    faqAnnam: "How do I use Annam?",
    faqAnnamAntwort: "Annam is your personal AI health advisor. You can communicate with her by text or voice. She knows your phenotype and gives you personalised recommendations for nutrition, exercise and mindfulness.",
    faqTagebuch: "How does the diary work?",
    faqTagebuchAntwort: "In the diary you can record your mood, nutrition and activities daily. Annam analyses your entries and gives you personalised tips. The more regularly you write, the better the recommendations become.",
    faqSessions: "What are the audio sessions?",
    faqSessionsAntwort: "The sessions are guided audio exercises for meditation, breathing techniques and relaxation. 5 basic sessions are included for free. With a premium package you get access to personalised sessions.",
    faqDokumente: "Can I upload documents?",
    faqDokumenteAntwort: "Yes! In the documents section you can upload lab results, doctor's reports and other health documents. Annam can take these into account during consultations (premium feature).",
    faqCommunity: "How does the community work?",
    faqCommunityAntwort: "In the community you can connect with other AYU users. There are various channels for topics such as recipes, experiences and general discussions.",
    faqDaten: "Is my data secure?",
    faqDatenAntwort: "Yes, your data is stored encrypted and protected to the highest security standards. We do not share personal data with third parties. You can delete your account and all data at any time.",
  },

  feedback: {
    title: "Feedback",
    subtitle: "Share your experience with us",
    kategorie: "Choose category",
    freude: "Joy",
    freudeDesc: "What do you particularly like? Share your positive experiences",
    anmerkung: "Note",
    anmerkungDesc: "Suggestion for improvement, idea or general comment",
    fehlfunktion: "Malfunction",
    fehlfunktionDesc: "Something is not working as expected",
    fehlfunktionKritisch: "Critical malfunction",
    fehlfunktionKritischDesc: "App unusable or data loss",
    betroffeneSeite: "Affected page",
    kurzbeschreibung: "Short description",
    detailliert: "Detailed description",
    screenshot: "Upload screenshot",
    absenden: "Send feedback",
    pflichtfelder: "Please fill in all required fields",
    seitePflicht: "Please select the affected page",
    bildZuGross: "Image too large (max. 5 MB)",
    sendeError: "Error sending",
    dankeFreude: "Thank you for your positive feedback!",
    dankeAnmerkung: "Thank you for your note!",
    dankeFehler: "Error report sent!",
    weiteresFeedback: "Send more feedback",
    zurueck: "Back to app",
    allgemein: "General / Cross-cutting",
    anderesSeite: "Other page...",
    optional: "(optional)",
    seitePflichtLabel: "Affected page",
    seiteAuswaehlen: "Select page...",
    sonstSeite: "Which page? (e.g. /app/...)",
    kurzbeschreibungLabel: "Short description",
    detailliertLabel: "Detailed description",
    screenshotOptional: "Screenshot",
    klickeOderZiehe: "Click here or drag an image here",
    maxDateigroesse: "Max. 5 MB (JPG, PNG)",
    screenshotVorschau: "Screenshot preview",
    abbrechen: "Cancel",
    meldungSenden: "Submit report",
    dankeTitle: "Thank you for your feedback!",
    dankePositivTitle: "Thank you for your feedback!",
    dankeFehlerTitle: "Thank you!",
    dankePositivDesc: "Your feedback helps us make AYU even better. We appreciate every response!",
    dankeFehlerDesc: "Your report has been successfully sent. Our team will take care of it.",
    weiteresFeedbackBtn: "More feedback",
    zurueckHilfe: "Back to help",
    wasNachricht: "What would you like to tell us?",
    pflichtMarkierung: "*",
    shortPlaceholderFreude: "What did you particularly like? (max. 1 sentence)",
    shortPlaceholderAnmerkung: "What is your suggestion or comment? (max. 1 sentence)",
    shortPlaceholderFehler: "What is the problem? (max. 1 sentence)",
    detailPlaceholderFreude: "Tell us more: What exactly impressed you? Which function, which experience?",
    detailPlaceholderAnmerkung: "Describe your idea in more detail: What would you wish for? How do you envision it?",
    detailPlaceholderFehler: "Describe the problem in more detail: What did you do? What happened? What did you expect?",
    feedbackTitle: "Feedback",
    feedbackSubtitle: "Your feedback helps us improve AYU — whether joy, idea or bug report",
  },

  landing: {
    nav: {
      wasIstAyu: "What is AYU?",
      ayurveda: "Ayurveda",
      phaenotypen: "Phenotypes",
      ayuKompass: "AYU Compass",
      tagebuch: "Journal",
      annam: "Annam",
      betreuer: "Coaches",
      ayuErleben: "Experience AYU",
      bookStore: "Book Store",
      faq: "FAQ",
      jetztStarten: "Get started",
    },
    hero: {
      badge: "Tradition meets Genetics",
      heading1: "Your",
      heading2: "personal",
      heading3: "Health Plan",
      subtitle: "5,000 years of Ayurvedic wisdom, personalised through modern science. Discover your unique phenotype and live the health that suits you.",
      ctaStart: "Start Assessment now",
      ctaLearnMore: "Learn more",
      annamTitle: "Annam Hanfstein",
      annamRole: "Founder & CEO – AYU-rveda",
    },
    stats: {
      menschen: "People accompanied",
      jahre: "Years of Ayurveda",
      phaenotypen: "Phenotypes",
      personalisiert: "Personalised",
    },
    wasIstAyu: {
      badge: "How it works",
      heading: "What is AYU?",
      description: "AYU is your personalised health and lifestyle system. It combines millennia-old Ayurvedic wisdom with modern science to create a health plan that truly fits you.",
      step1Title: "Fill in the questionnaire",
      step1Desc: "In about 15 minutes you answer questions about your origins, lifestyle, nutrition and mental wellbeing.",
      step2Title: "Your phenotype is determined",
      step2Desc: "Our system analyses your answers and assigns you to one of 12 human phenotypes – based on genetics, culture and environment.",
      step3Title: "Your personal AYU is created",
      step3Desc: "You receive an individual health plan: nutrition, routines, movement, mental balance – everything tailored to you.",
    },
    ayurveda: {
      badge: "The foundation",
      heading: "What is Ayurveda?",
      quote: "\"Ayurveda is more than a healing method – it is one of the oldest documented systems for health and lifestyle.\"",
      p1: "Ayurveda is one of the oldest documented health systems of humanity. Its origins stretch back over 5,000 years and are rooted in the Vedic culture of India.",
      p2Text: "While Western medicine asks",
      p2Western: "How does illness arise?",
      p2Text2: ", Ayurveda asks:",
      p2Ayurveda: "How does health arise – and how is it maintained?",
      p3: "AYU brings this millennia-old wisdom into the modern age – personalised through modern genetics and adapted to your individual life situation.",
      pathogenesisTitle: "Pathogenesis",
      pathogenesisDesc: "How does illness arise?",
      ayurvedaTitle: "Ayurveda",
      ayurvedaDesc: "How does health arise and persist?",
      pillarsHeading: "The 5 pillars of your AYU",
      pillar1Title: "Nutrition",
      pillar1Desc: "Personalised recommendations based on your phenotype – not on general trends.",
      pillar2Title: "Movement",
      pillar2Desc: "The right type and intensity of exercise for your body type and lifestyle.",
      pillar3Title: "Mental Balance",
      pillar3Desc: "Mindfulness exercises and routines that suit your personal constitution.",
      pillar4Title: "Daily Rhythm",
      pillar4Desc: "Optimal times for eating, sleeping and activity – aligned to your inner clock.",
      pillar5Title: "Prevention",
      pillar5Desc: "Recognise early what your body needs – before symptoms arise.",
    },
    phenotyp: {
      badge: "The science behind it",
      heading1: "12",
      heading2: "Phenotypes",
      intro: "Every person is unique. Through our questionnaires we determine your individual phenotype – one of 12 basic types arising from three factors:",
      genetikTitle: "Genetics",
      genetikDesc: "Your DNA determines fundamental predispositions – from metabolism to stress response.",
      kulturTitle: "Culture",
      kulturDesc: "Your cultural background influences dietary habits, rhythms and values.",
      umweltTitle: "Environment",
      umweltDesc: "Climate, lifestyle and social environment shape your daily health needs.",
      statement: "\"Why traditional Ayurveda can do you more harm than good.\"",
      statementDesc: "Europe is not India. Copying Ayurveda 1:1 from Kerala to Munich does not automatically produce the same effect. AYU personalises Ayurveda for your actual life situation.",
    },
    kompass: {
      badge: "Your companion",
      heading: "The AYU Compass",
      p1: "After your assessment you gain access to the AYU Compass – your personal health companion. It guides you day by day through recommendations tailored precisely to your phenotype.",
      p2: "Your AYU is your personal AI health assistant. Ask it any time about nutrition, routines or wellbeing – it knows your phenotype and gives you answers that truly suit you.",
      chatHeader: "My Health Journal",
      chatSubheader: "AYU Reflection active",
      inputPlaceholder: "What's on your mind?",
      feature1: "Your personal AYU Chat Assistant",
      feature2: "Daily personalised recommendations",
      feature3: "Your health journal",
      feature4: "Progress tracking",
      feature5: "Seasonal adjustments",
      feature6: "Weekly rituals & routines",
    },
    tagebuch: {
      badge: "New: Health Journal",
      heading1: "Not just writing.",
      heading2: "Understanding.",
      description: "Your AYU Health Journal is more than a blank page. It is a conversation with your body – accompanied by a reflection partner who listens, recognises patterns and asks the right questions.",
      chatHeader: "My Health Journal",
      chatSubheader: "AYU Reflection active",
      inputPlaceholder: "What's on your mind?",
      ctaButton: "Discover the journal",
      feature1Title: "Reflect",
      feature1Desc: "Capture what moves you – thoughts, feelings, physical signals. Annam listens without judgement.",
      feature2Title: "Understand",
      feature2Desc: "AYU mirrors your words back and helps you recognise patterns in your health that would otherwise remain hidden.",
      feature3Title: "Document",
      feature3Desc: "Every entry becomes part of your personal health journey. Over time you will see how your wellbeing changes.",
      feature4Title: "Grow",
      feature4Desc: "No journal that gathers dust. A living dialogue that brings you a step closer to your balance every day.",
    },
    annam: {
      badge: "The founder",
      heading1: "One woman. One",
      heading2: "Mission",
      annamTitle: "Annam Hanfstein",
      annamRole: "Founder & CEO – AYU-rveda",
      quote: "\"You feel my dedication in every recommendation, every ritual – and in every moment you feel seen, understood and empowered.\"",
      p1: "Annam Hanfstein was practically born into Ayurveda – as the daughter of a traditional Indian healing family, she was raised early in the principles of balance, healing and energy.",
      p2: "To date she has accompanied over 180,000 people on their path to health, inner calm and personal development – through Ayurveda, mindfulness and lived wisdom.",
      p3: "With AYU she now brings her decades of experience into a system that gives every person individual access to this ancient teaching – adapted to the modern world in which we live.",
      chrisTitle: "Christopher Hanfstein",
      chrisDesc: "Health-Tech investor & founder of GENOpuzzle.com – the technological mind behind the AYU system.",
    },
    betreuer: {
      badge: "Real people. Real understanding.",
      heading: "Your coaching team",
      description: "You are not booking an anonymous appointment. You are meeting people who listen, understand and advise you honestly.",
      lilliName: "Lilli",
      lilliRole: "Nutritional Advisor & Mental Coach",
      lilliDesc: "Mother of two and passionate about sport. Since 2015 she has been guiding people on their path to more health, energy and sustainable balance. Her approach combines science-based nutritional strategies with mental work for lasting behavioural change.",
      lilliTag1: "Nutrition",
      lilliTag2: "Mental coaching",
      lilliTag3: "Holistic",
      silkeName: "Silke",
      silkeRole: "Holistic Nutritional Advisor & Coach",
      silkeDesc: "My vision is to support people on a holistic level so they can reclaim their own body awareness and create a healthy, content and happy life from it.",
      silkeTag1: "Nutrition",
      silkeTag2: "Coaching",
      silkeTag3: "Body awareness",
      susanName: "Susan",
      susanRole: "Nutritional Advisor & Health Coach",
      susanDesc: "Through her own experience with cancer and thyroid problems Susan has learned how important health and conscious nutrition are for our lives. Today she passes on her knowledge and shows others how much our health can depend on our lifestyle.",
      susanTag1: "Nutrition",
      susanTag2: "Health coaching",
      susanTag3: "Prevention",
    },
    testimonials: {
      badge: "Experiences",
      heading: "What people say about AYU",
      t1: "AYU gave me a clarity I didn't know I was missing. Instead of endless advice, I finally understood what really matters for my body.",
      t2: "What impressed me most was how practical everything was. No pressure, no extremes – just clear priorities I can actually live with.",
      t3: "I have tried many health approaches, but AYU was the first that felt personal without being overwhelming.",
      t4: "AYU doesn't tell you what to do – it helps you understand yourself. That alone changed how I approach my health.",
      t5: "Instead of chasing optimisation, AYU gave me orientation. That made my routines sustainable for the first time.",
      t6: "For the first time health advice felt adapted to my real life, not to an idealised version of it.",
    },
    targetGroup: {
      badge: "Who is AYU for?",
      heading1: "AYU is for",
      heading2: "you",
      description: "Wherever you are in life – AYU gives you the clarity you need.",
      group1Title: "Parents & Families",
      group1Desc: "Balancing between family and their own energy",
      group2Title: "Professionals",
      group2Desc: "Under constant pressure and performance demands",
      group3Title: "Entrepreneurs",
      group3Desc: "Who want to sustainably optimise their performance",
    },
    faq: {
      badge: "Frequently asked questions",
      heading1: "Everything you need",
      heading2: "to know",
      q1: "What is AYU?",
      a1: "AYU is a personalised health and lifestyle system. It connects the principles of Ayurveda with modern AI-driven pattern recognition to help you understand your body, mind and lifestyle – and translate that knowledge into practical, daily recommendations.",
      q2: "Is AYU a medical service?",
      a2: "No. AYU is exclusively preventive and educational. It does not diagnose, treat or replace medical advice. It helps you understand patterns, priorities and habits that support your long-term wellbeing.",
      q3: "How does personalisation work?",
      a3: "You complete a structured questionnaire covering family backgrounds, mental patterns and lifestyle factors. AYU analyses this information and identifies your personal phenotype – one of 12 human basic types based on genetics, culture and environment.",
      q4: "Do I need prior knowledge of Ayurveda?",
      a4: "Not at all. AYU is designed for modern life. No Sanskrit terms, no rigid rules, no belief system. Everything is clearly explained and translated into everyday actions.",
      q5: "What do I receive after the assessment?",
      a5: "You receive a personalised AYU report with clear recommendations on nutrition, routines, movement, mental balance and long-term preventive priorities – tailored to your life, not to an idealised routine.",
      q6: "Who is AYU suitable for?",
      a6: "AYU is for people who want clarity over confusion – parents, professionals, entrepreneurs or anyone who wants to take responsibility for their long-term health without obsession, trends or overwhelm.",
      q7: "What distinguishes AYU from traditional Ayurveda?",
      a7: "Traditional Ayurveda was developed for people in India. AYU acknowledges that we differ in genetics, culture and environment. A system that works in Kerala does not automatically translate to Munich, New York or Sydney. AYU personalises Ayurveda for your actual life situation.",
      q8: "What does AYU cost?",
      a8: "AYU offers various access options – from the basic assessment to the comprehensive health plan with DNA analysis. Start with the free initial consultation to find out which path is right for you.",
    },
    zweiWege: {
      badge: "Your path",
      heading1: "Two paths to",
      heading2: "your AYU",
      description: "Choose the access that suits you best. In the free consultation we will find out together which path is right for you.",
      recommended: "Recommended",
      path1Title: "AYU Health Programme",
      path1Subtitle: "Your personal health plan",
      path1Desc: "Based on the AYU phenotype system you receive your individual health plan with AI coach, daily routine and nutritional recommendations.",
      path1F1: "Personal AYU Phenotype Test (12 types)",
      path1F2: "AI-powered health coach (text + voice)",
      path1F3: "Personalised daily routine (Dinacharya)",
      path1F4: "Individual nutrition plan & recipes",
      path1F5: "Guided audio sessions",
      path1F6: "Health journal with AI analysis",
      path1F7: "Progress tracking & streaks",
      path1F8: "Telegram bot for on the go",
      path2Title: "AYU + Genetic Gut Microbiome Test",
      path2Subtitle: "The full depth",
      path2Desc: "Everything from the AYU Programme plus genetic gut microbiome analysis for even more precise, science-based recommendations.",
      path2F1: "Everything from the AYU Health Programme",
      path2F2: "Genetic gut microbiome test (lab analysis)",
      path2F3: "Detailed microbiome evaluation in the dashboard",
      path2F4: "Even more precise nutritional & health recommendations",
      path2F5: "Personal consultation on the microbiome analysis",
      ctaButton: "Book a consultation",
      footnote: "In the free consultation we will discuss together which programme suits you best.",
    },
    video: {
      badge: "Introduction",
      heading: "Annam explains AYU",
      description: "Discover in this video how AYU works and why personalised Ayurveda is the key to your health.",
      previewTitle: "AYU – Your personal health plan",
      previewSubtitle: "Annam introduces AYU",
      videoPreview: "Video preview",
      playAriaLabel: "Play video",
    },
    cta: {
      heading1: "Ready to",
      heading2: "understand yourself",
      description: "Your personal assessment takes about 15 minutes. No commitment. No medical diagnosis. Just clarity.",
      button: "Start Assessment now",
      trust: "Over 180,000 people already trust Annam's expertise",
    },
    buch: {
      badge: "The Book",
      heading: "Der AYU",
      subtitle: "Tradition meets Genetics",
      description: "Why traditional Ayurveda does not work in Europe – and how the AYU approach changes that. By Annam & Christopher Hanfstein. Available as e-book and print edition, in German and English.",
      stars: "Reader reviews",
      ebookFrom: "E-book from",
      print: "Print",
      cta: "Learn more & order",
    },
    footer: {
      description: "AYU connects 5,000 years of Ayurvedic wisdom with modern science for your personal health plan.",
      navigation: "Navigation",
      mehr: "Discover more",
      assessment: "AYU Assessment",
      ayuErlebenDemo: "Experience AYU (Demo)",
      ayuErleben: "Experience AYU",
      video: "Video",
      terminBuchen: "Book appointment",
      kontakt: "Contact",
      rechtliches: "Legal",
      datenschutz: "Privacy policy",
      impressum: "Imprint",
      agb: "T&Cs",
      copyright: "AYU Healthtech LIMITED. All rights reserved.",
      disclaimer: "AYU is a preventive lifestyle system and does not replace medical advice.",
    },
  },

  ayuErleben: {
    hero: {
      badge: "AYU Experience",
      heading1: "Your day with",
      description: "Not a one-time test. Not a static report. But a living system that accompanies you every day — based on your unique phenotype and millennia-old Ayurvedic wisdom.",
    },
    timeline: {
      badge: "Your Daily Schedule",
      heading1: "A day in your",
      heading2: "Ayurvedic Health System",
      description: "From morning to evening — your AYU Health Coach guides you through the day with recommendations based on your phenotype.",
      phoneTitle: "AYU Health Coach",
      phoneSub: "Daily companion active",
      inputPlaceholder: "What's on your mind?",
      labelCoach: "AYU HEALTH COACH",
      labelRec: "RECOMMENDATION",
      labelTip: "TIP",
      labelBreath: "BREATHING EXERCISE",
      labelBalance: "DAILY SUMMARY",
      slot1Title: "Morning Check-in",
      slot1DateLabel: "07:00 — Morning Check-in",
      slot1Bot1: "Good morning! Your sleep score shows 7.4h with a good deep sleep phase. Your phenotype benefits today from warm ginger water and a light yoga session.",
      slot1Bot2: "Your Agni — your digestive fire — is strongest in the morning. Perfect time for a nutritious breakfast with oatmeal, cinnamon, and warm ghee.",
      slot1User1: "Should I do yoga or a walk this morning?",
      slot1Bot3: "For your phenotype and today's weather: 15 minutes of Sun Salutation, followed by 10 minutes of Pranayama. This activates your metabolism gently and sustainably.",
      slot2Title: "Lunchtime Recommendation",
      slot2DateLabel: "12:30 — Lunchtime Recommendation",
      slot2Bot1: "Lunchtime! Your phenotype shows a tendency towards afternoon fatigue. Recommendation: A warm meal with turmeric and cumin strengthens your Agni.",
      slot2User1: "I only have 20 minutes break. What's quick?",
      slot2Bot2: "Kitchari — rice with mung beans and spices. You can prepare it in the morning and reheat it. Avoid cold drinks — they slow down your digestion.",
      slot2Bot3: "A 15-minute walk after eating activates your metabolism. Even 5 minutes already helps.",
      slot3Title: "Afternoon Boost",
      slot3DateLabel: "16:00 — Afternoon Boost",
      slot3Bot1: "Your energy level typically drops at this time. Instead of coffee, I recommend Tulsi tea — it fits perfectly with your phenotype.",
      slot3User1: "Why no coffee? I need the kick...",
      slot3Bot2: "Coffee temporarily increases your cortisol, but for your phenotype this leads to sleep problems in the evening. Tulsi regulates your cortisol gently from within.",
      slot3Bot3: "Add 5 minutes of Pranayama: inhale for 4 seconds, hold for 7, exhale for 8. This gives you natural energy without the crash.",
      slot4Title: "Evening Routine",
      slot4DateLabel: "21:00 — Evening Routine",
      slot4Bot1: "Time for your evening routine. Your phenotype is sensitive to blue light — avoid screens from now on.",
      slot4User1: "What can I do instead?",
      slot4Bot2: "Recommendation: Warm Golden Milk with Ashwagandha and nutmeg. Plus 10 minutes of light stretching or journaling.",
      slot4Bot3: "Your diary entry today shows positive development: Energy +12% this week, sleep quality improved. Keep it up! Good night.",
    },
    diary: {
      badge: "Health Diary",
      heading1: "Not just writing.",
      heading2: "Understanding.",
      description: "Your AYU Health Diary is more than a blank page. It's a conversation with your body — accompanied by a reflection partner who listens, recognizes patterns, and asks the right questions.",
      phoneTitle: "My Health Diary",
      phoneSub: "AYU Reflection active",
      ctaButton: "Discover diary",
      labelReflect: "AYU REFLECTION",
      labelPattern: "PATTERN RECOGNIZED",
      labelWeekly: "WEEKLY REPORT",
      labelMonthly: "MONTHLY REPORT",
      f1Title: "Reflect",
      f1Desc: "Record what moves you — thoughts, feelings, physical signals. Annam listens without judgment.",
      f1DateLabel: "Diary — Reflect",
      f1User1: "Today I feel heavy and listless. Is it my diet?",
      f1Bot1: "That sounds like your body is sending you a signal. For your phenotype, heaviness can show up especially during transition periods.",
      f1Bot2: "Your Agni (digestive fire) needs support now — warm, light foods with ginger and cumin can help.",
      f2Title: "Understand",
      f2Desc: "AYU mirrors your words back and helps you recognize patterns in your health that would otherwise remain hidden.",
      f2DateLabel: "Diary — Understand",
      f2User1: "I've noticed that I always get tired after lunch.",
      f2Bot1: "Your entries over the past 2 weeks show a clear pattern: On days with cold lunch, your energy level drops by 40%.",
      f2Bot2: "Your phenotype needs warm meals at lunchtime. This strengthens your Agni and prevents the afternoon slump.",
      f3Title: "Document",
      f3Desc: "Every entry becomes part of your personal health journey. Over time, you recognize how your well-being changes.",
      f3DateLabel: "Diary — Document",
      f3Bot1: "Your weekly report is here! Here are your highlights:",
      f3Bot2: "• Nutrition: 6/7 days warm meals ✓\n• Exercise: 5/7 days active ✓\n• Sleep: Avg. 7.2 hours\n• Mood: Upward trend ↑",
      f3User1: "That motivates me to keep going!",
      f4Title: "Grow",
      f4Desc: "Not a diary that collects dust. A living dialogue that brings you a little closer to your balance every day.",
      f4DateLabel: "Diary — Grow",
      f4Bot1: "Your monthly report for February is here! Impressive development:",
      f4Bot2: "• Energy level: +35% compared to January\n• Digestion: Significantly improved\n• Sleep: From 5.8 to 7.4\n• Stress level: -20%",
      f4Bot3: "Your body is responding positively to the Ayurvedic adjustments. In March, we'll focus on your evening routine — that has the most potential.",
    },
    wearables: {
      badge: "Connect everything",
      heading1: "Your data.",
      heading2: "One system.",
      description: "AYU connects your phenotype with current data from wearables, blood tests, and your diary into a holistic health picture.",
      ouraName: "Oura Ring",
      ouraMetrics: "Sleep, HRV, Temperature",
      whoopName: "Whoop",
      whoopMetrics: "Strain, Recovery, Sleep",
      garminName: "Garmin",
      garminMetrics: "Activity, Stress, Sleep",
      fitbitName: "Fitbit",
      fitbitMetrics: "Steps, HRV, SpO2",
      withingsName: "Withings",
      withingsMetrics: "Weight, Blood Pressure, ECG",
      polarName: "Polar",
      polarMetrics: "Training, HRV, Sleep",
      bloodName: "Blood Tests",
      bloodMetrics: "CRP, Vitamin D, Iron",
    },
    cta: {
      heading1: "Ready to discover your",
      heading2: "phenotype?",
      description: "What you've just seen is just a small glimpse. With your personal AYU assessment, you receive recommendations tailored exactly to your phenotype.",
      button: "Start your AYU Journey",
      time: "15 minutes",
      free: "Start for free",
      noObligation: "No commitment",
      backLink: "← Back to overview",
    },
  },

  erleben: {
    hero: {
      badge: "This is what an AYU session sounds like",
      heading1: "Experience AYU.",
      heading2: "Without any pressure.",
      description: "Choose a topic that resonates with you. Observe how AYU listens, analyzes, and gives the right recommendations.",
    },
    topics: {
      t1Title: "Longevity",
      t1Subtitle: "Healthy aging & neuroprotection",
      t1M1: "New Health Session",
      t1M2: "Hello. I'm glad you're taking this moment. When you think about your aging — what concerns you most? Be completely honest.",
      t1M3: "I notice I'm becoming more forgetful. Sometimes I can't find words. And I'm only 42. It scares me.",
      t1M4: "That's an important clue. Forgetfulness at your age is rarely a sign of decline — it often shows that your nervous system is overloaded. Your brain prioritizes stress management over memory.",
      t1M5: "So it's stress? But I sleep enough...",
      t1M6Label: "PATTERN RECOGNIZED",
      t1M6: "Sleep quantity is not sleep quality. Your phenotype shows a tendency to shallow sleep with high cortisol activity in the early morning hours. This means: Your brain doesn't fully regenerate at night. The Ayurvedic Rasayanas — rejuvenating remedies — address exactly this.",
      t1M7: "Session Summary",
      t1M8Label: "YOUR HEALTH MOMENT",
      t1M8: "Your forgetfulness is not a sign of aging — it's a signal from your nervous system. With targeted neuroprotection through adapted Rasayana protocols and sleep optimization, you can not only maintain but improve your cognitive clarity.",
      t2Title: "Gut-Brain Axis",
      t2Subtitle: "Microbiome & mental health",
      t2M1: "New Health Session",
      t2M2: "Welcome. Let's talk about something most people underestimate: the connection between your gut and your head. How is your digestion — honestly?",
      t2M3: "Well, I constantly have bloating and feel tired after eating. And somehow I'm often irritable for no reason.",
      t2M4: "That's no coincidence. Ayurveda has been saying for 5,000 years: 'All disease begins in the gut.' Modern science now confirms this. Your gut produces 90% of your serotonin — when it's disturbed, your mood suffers directly.",
      t2M5: "So my irritability comes from my stomach?",
      t2M6Label: "PATTERN RECOGNIZED",
      t2M6: "Exactly. Your phenotype shows a digestive sensitivity that directly affects your emotional balance. The gut-brain axis is particularly active in you. This means: When we strengthen your Agni — your digestive fire — not only bloating improves, but also your mental clarity and composure.",
      t2M7: "Session Summary",
      t2M8Label: "YOUR HEALTH MOMENT",
      t2M8: "Your irritability is not a character weakness — it's a signal from your microbiome. Through targeted strengthening of your digestive fire with phenotype-specific herbs and nutritional adjustments, you can simultaneously transform your digestion and your emotional balance.",
      t3Title: "Adaptogens",
      t3Subtitle: "Natural power against stress",
      t3M1: "New Health Session",
      t3M2: "Hello. Let's talk about something that's currently moving the world: Adaptogens. Plants like Ashwagandha have 670 million views on TikTok. But what do they mean for you personally?",
      t3M3: "I've been taking Ashwagandha capsules from the internet for months. Honestly, I don't notice much. Maybe I'm doing something wrong?",
      t3M4: "You're not doing anything 'wrong' — but you're taking a remedy that doesn't match your phenotype. Ashwagandha is not equally effective for everyone. For some constitutions, it can even be counterproductive.",
      t3M5: "Really? But everyone says it helps against stress...",
      t3M6Label: "PATTERN RECOGNIZED",
      t3M6: "That's the problem with one-size-fits-all trends. Your phenotype shows a stress response that responds better to Brahmi and Tulsi than to Ashwagandha. The difference: Ashwagandha calms the nervous system from the outside, while Brahmi regulates your specific type of overstimulation from within. Personalization is the key.",
      t3M7: "Session Summary",
      t3M8Label: "YOUR HEALTH MOMENT",
      t3M8: "Not every adaptogen suits every person. Instead of blindly following trends, you need the plant that matches your phenotype. AYU identifies exactly that — based on your genetics, culture and environment, not on TikTok algorithms.",
    },
    chat: {
      healthLabel: "AYU Health",
      sessionActive: "Session active",
      sessionComplete: "Session complete",
      skipButton: "Skip",
      inputPlaceholder: "This is a demo session...",
      completionText: "Select a different topic above to experience another session.",
    },
    method: {
      badge: "What you just saw",
      heading1: "The AYU",
      heading2: "3-Step Method",
      step1Title: "Holistic Analysis",
      step1Desc: "AYU captures your complete picture — nutrition, sleep, stress, digestion — and recognizes connections that remain hidden from you.",
      step2Title: "Pattern Recognition",
      step2Desc: "Your symptoms are not viewed in isolation. AYU connects them with your phenotype and shows you the true causes.",
      step3Title: "Personalized Recommendation",
      step3Desc: "No generic tips — but recommendations that fit exactly your constitution, culture, and life situation.",
    },
    stats: {
      badge: "You are not alone",
      heading: "Over 2.5 billion people worldwide suffer from chronic health problems that could be prevented.",
      stat1Value: "1.7 Bn.",
      stat1Label: "Chronic digestive problems",
      stat2Value: "670 M.",
      stat2Label: "Ashwagandha views on TikTok",
      stat3Value: "1 in 3",
      stat3Label: "People with sleep disorders",
      source: "Sources: WHO Global Health Report 2025, TikTok Analytics 2026",
    },
    cta: {
      heading1: "Ready to experience it",
      heading2: "yourself?",
      description: "What you just saw is just a small glimpse. With your personal AYU assessment, you receive recommendations tailored exactly to your phenotype.",
      button: "Start your AYU Journey",
      time: "15 minutes",
      free: "Start for free",
      noObligation: "No commitment",
      email: "Prefer email?",
    },
  },

  errors: {
    allgemein: "An error occurred. Please try again.",
    netzwerk: "Network error. Please check your connection.",
    laden: "Failed to load data.",
    speichern: "Failed to save data.",
    nichtGefunden: "Page not found.",
    zugriffVerweigert: "Access denied.",
  },

  video: {
    navCta: "Book appointment",
    heroBadge: "Exclusive Video",
    heroTitle1: "Discover how AYU",
    heroTitle2: "accompanies you",
    heroDesc: "Take a moment. This video shows you what AYU can do for you — honest, clear and without promises.",
    iframeTitle: "AYU – Your Personal Health Plan",
    badgeFree: "Free",
    badgeNoDiagnosis: "No Diagnosis",
    badgeNoObligation: "No Obligation",
    demoBadge: "Try it yourself",
    demoTitle1: "Try AYU now —",
    demoTitle2: "7 minutes, free",
    demoDesc: "Experience the AYU app live with the demo account of Max Muster. Explore the dashboard, the AI coach and the daily routine — no registration needed.",
    demoLiveDuration: "7 minute live demo",
    demoNoRegistration: "No registration needed",
    demoAllFeatures: "Discover all features",
    demoButton: "Start demo",
    ctaBadge: "Your next step",
    ctaTitle: "Ready for a personal conversation?",
    ctaDesc: "You've seen what AYU can do. Now is the moment to take the next step. Book a free consultation — no obligation, personal and tailored just for you.",
    ctaBadge1: "100% free & no obligation",
    ctaBadge2: "Approx. 20 minutes",
    ctaBadge3: "Personal consultation",
    ctaButton: "Book appointment now",
    quoteText: "I look forward to meeting you personally and discovering together how AYU can accompany you on your journey.",
    quoteAuthor: "Annam Hanfstein",
    quoteRole: "Founder of AYU · Ayurveda Coach",
    footerImpressum: "Imprint",
    footerDatenschutz: "Privacy",
    footerKontakt: "Contact",
    footerDisclaimer: "AYU is a preventive lifestyle system and does not replace medical advice.",
  },

  demoRegistration: {
    navBack: "Back to homepage",
    heroBadge: "7-Minute Demo",
    heroTitle1: "Experience AYU in",
    heroTitle2: "7 minutes",
    heroDesc: "Discover your personal Ayurveda health plan. Register briefly and start the interactive demo right away — free and without obligation.",
    trustBadge1: "Interactive demo with AI coach",
    trustBadge2: "Your data is GDPR-compliant protected",
    trustBadge3: "Free and without obligation",
    successTitle: "Perfect, let's go!",
    successDesc: "Your registration was successful. The demo is loading now...",
    successLoading: "Demo is starting...",
    formTitle: "Start demo",
    formSubtitle: "Register briefly to experience the AYU demo",
    labelFirstName: "First name",
    placeholderFirstName: "Max",
    labelLastName: "Last name",
    placeholderLastName: "Mustermann",
    labelEmail: "Email address",
    placeholderEmail: "max@example.com",
    labelPhone: "Phone number",
    placeholderPhone: "+49 170 1234567",
    submitLoading: "Loading...",
    submitButton: "Start demo",
    privacyText: "By registering you agree to our",
    privacyLink: "Privacy Policy",
    privacyAfter: ". We never share your data with third parties.",
    footerImpressum: "Imprint",
    footerDatenschutz: "Privacy",
    errorFirstName: "Please enter your first name",
    errorLastName: "Please enter your last name",
    errorPhoneRequired: "Please enter your phone number",
    errorPhoneInvalid: "Please enter a valid phone number (e.g. +49 170 1234567)",
    errorEmailRequired: "Please enter your email address",
    errorEmailInvalid: "Please enter a valid email address",
    errorGeneral: "An error occurred. Please try again.",
  },

  registrierung: {
    navBack: "Back",
    stepIndicator: "Step 1 of 3",
    heroTitle1: "Start your",
    heroTitle2: "personal",
    heroTitle3: "AYU Journey",
    heroDesc: "Register for free and get instant access to your personalized health video. No obligation, no subscription.",
    trustBadge1: "Your data is GDPR-compliant protected",
    trustBadge2: "100% free and without obligation",
    trustBadge3: "Instant access after registration",
    alreadyLoggedInTitle: "You are already logged in",
    alreadyLoggedInDesc: "Welcome back",
    alreadyLoggedInDescSuffix: "! You already have an AYU account. We are redirecting you to your app...",
    redirectingToApp: "Redirecting to app...",
    goToApp: "Go to app now",
    alreadyRegisteredTitle: "We already know you!",
    alreadyRegisteredDesc: "You have already registered with this email address. You will be redirected to your video shortly...",
    successTitle: "Welcome to AYU!",
    successDesc: "Your registration was successful. You will be redirected to your video shortly...",
    redirecting: "Redirecting...",
    formTitle: "Register for free",
    formSubtitle: "Get instant access to your personalized video",
    labelFirstName: "First name",
    placeholderFirstName: "Max",
    labelLastName: "Last name",
    placeholderLastName: "Mustermann",
    labelPhone: "Phone number",
    placeholderPhone: "+49 170 1234567",
    labelEmail: "Email address",
    placeholderEmail: "max@example.com",
    submitLoading: "Sending...",
    submitButton: "Register for free",
    privacyText: "By registering you agree to our",
    privacyLink: "Privacy Policy",
    privacyAfter: ". We never share your data with third parties.",
    footerImpressum: "Imprint",
    footerDatenschutz: "Privacy",
    errorFirstNameRequired: "Please enter your first name.",
    errorFirstNameMinLength: "The first name must be at least 2 characters long.",
    errorFirstNameInvalid: "Please enter a valid first name (letters, spaces, hyphens only).",
    errorLastNameRequired: "Please enter your last name.",
    errorLastNameMinLength: "The last name must be at least 2 characters long.",
    errorLastNameInvalid: "Please enter a valid last name (letters, spaces, hyphens only).",
    errorPhoneRequired: "Please enter your phone number.",
    errorPhoneInvalid: "Please enter a valid phone number (e.g. +49 170 1234567).",
    errorEmailRequired: "Please enter your email address.",
    errorEmailInvalid: "Please enter a valid email address (e.g. max@example.com).",
    errorGeneral: "An error occurred. Please try again.",
  },

  funnel: {
    navCta: "Discover now",
    heroBadge: "Your body. Your balance.",
    heroTitle1: "Your body knows",
    heroTitle2: "what you need",
    heroDesc: "AYU is your personal health companion. No doctor. No trend. A system — that connects 5,000 years of Ayurveda wisdom with your unique genetics.",
    heroCtaPrimary: "Discover for free",
    heroCtaSecondary: "Learn more",
    heroBadgeDsgvo: "GDPR-compliant",
    heroBadgeNatural: "100% natural",
    heroBadgePersonalized: "Personalized",
    painBadge: "Does this sound familiar?",
    painTitle1: "When everything feels",
    painTitle2: "too much",
    painTitle3: "",
    pain1Title: "Digestive problems",
    pain1Text: "Bloating, fatigue after eating, a feeling of heaviness. Your body is telling you something — but you don't know what.",
    pain2Title: "Lack of energy",
    pain2Text: "You sleep enough, eat healthy — and are still exhausted. As if your body is working against you.",
    pain3Title: "Skin problems & restlessness",
    pain3Text: "Blemished skin, inner restlessness, sleep disorders. Symptoms that no doctor can properly identify.",
    pain4Title: "Information overload",
    pain4Text: "Every podcast, every book says something different. You've tried everything — and nothing really fit.",
    painOutro: "All of this is normal. And there is a way to deal with it — without pressure, without diagnosis, without judgment.",
    feelBadge: "How AYU feels",
    feelTitle1: "A system that",
    feelTitle2: "truly fits you",
    feelDesc: "Imagine finally having clarity about what your body really needs. Not based on trends, but on your unique constitution. That's exactly what AYU is.",
    feel1Title: "No judgment",
    feel1Text: "AYU doesn't judge. It analyzes your unique constitution — honestly and respectfully.",
    feel2Title: "Recognize patterns",
    feel2Text: "Over time, AYU shows you recurring health themes that you wouldn't see on your own.",
    feel3Title: "Your pace",
    feel3Text: "In the morning at breakfast or in the evening before bed — AYU adapts to your rhythm.",
    whatBadge: "What is AYU?",
    whatTitle1: "A mirror —",
    whatTitle2: "not a repair service",
    whatDesc: "AYU is a personalized health system. It connects 5,000 years of Ayurveda wisdom with modern science to help you understand your body — and translate that knowledge into practical, daily recommendations.",
    step1Num: "01",
    step1Title: "You answer",
    step1Text: "Through a questionnaire you share your story — origin, lifestyle, nutrition, wellbeing.",
    step2Num: "02",
    step2Title: "AYU analyzes",
    step2Text: "Your phenotype is determined — one of 12 basic types, based on genetics, culture and environment.",
    step3Num: "03",
    step3Title: "You live healthier",
    step3Text: "You receive a personalized plan: nutrition, routines, movement — everything tailored to you.",
    dnaBadge: "The body connection",
    dnaTitle1: "Your gut knows",
    dnaTitle2: "what you need",
    dnaDesc: "Holistic health doesn't only start in the mind. The optional microbiome DNA test analyzes over 1,900 microbiome positions and shows you precisely which of the 47 essential vital nutrients you are lacking — scientifically based and individual.",
    dnaFeature1: "1,900+ microbiome positions",
    dnaFeature2: "47 vital nutrients analyzed",
    dnaFeature3: "Scientifically based",
    dnaFeature4: "Individually tailored to you",
    dnaDisclaimer: "The DNA test is an optional extension. AYU works without it too — but with it you understand yourself on a whole new level.",
    dnaStatLabel: "Microbiome positions",
    dnaBenefit1: "Shows you exactly what your body is lacking",
    dnaBenefit2: "No guesswork — scientifically founded",
    dnaBenefit3: "Connects Ayurveda with body analysis",
    dnaBenefit4: "Developed by GENOpuzzle.com",
    pathsBadge: "Your path",
    pathsTitle: "Two ways to your balance",
    pathsDesc: "Choose the path that feels right for you. Both lead to more clarity.",
    path1Title: "AYU Reflexion",
    path1Sub: "Your health companion",
    path1Desc: "Your daily companion for holistic health. Answer the questionnaire and receive your personalized health plan.",
    path1Feature1: "Real-time phenotype determination",
    path1Feature2: "Personalized nutrition plan",
    path1Feature3: "Daily rhythm recommendations",
    path1Feature4: "24/7 available on your phone",
    path1Feature5: "Health journal",
    path1Cta: "Learn more",
    path2Badge: "Holistic",
    path2Title: "AYU + DNA Test",
    path2Sub: "The holistic connection",
    path2Desc: "Ayurveda wisdom meets scientific body analysis. Understand not only what you need — but also what your body is telling you.",
    path2Feature1: "Everything from AYU Reflexion",
    path2Feature2: "Microbiome DNA analysis",
    path2Feature3: "1,900+ microbiome positions",
    path2Feature4: "47 vital nutrients individually measured",
    path2Feature5: "Personal guidance from Annam",
    path2Cta: "Learn more",
    trustBadge: "Foundation",
    trustTitle: "Built on respect",
    trustDesc: "AYU is built on ethical foundations that guarantee a safe space — free from judgment and influence.",
    trust1Title: "Ayurveda-based",
    trust1Sub: "5,000 years of wisdom",
    trust2Title: "Holistic",
    trust2Sub: "Body & mind",
    trust3Title: "Encrypted",
    trust3Sub: "End-to-end",
    trust4Title: "100% anonymous",
    trust4Sub: "No sharing",
    trust5Title: "Always with you",
    trust5Sub: "On your phone",
    testimonialsBadge: "Voices",
    testimonialsTitle: "What others have experienced",
    founderBadge: "The story behind it",
    founderTitle1: "Why I created",
    founderTitle2: "AYU",
    founderTag1: "HealthTech Pioneer",
    founderTag2: "AYU-rveda.com",
    founderTag3: "Ayurveda Coach",
    founderText1: "Ayurveda was practically in my cradle — as the daughter of a traditional Indian healing family I was raised early with the principles of balance, healing and energy.",
    founderText2: "I have accompanied over 180,000 people on their journey to health and inner calm. Time and again I saw the same pattern: people who wanted to do everything right — but got the wrong recommendations because they didn't fit their type.",
    founderText3: "AYU is my answer to that. Not another health book. Not general advice. But a system that understands you as a unique person — and gives you exactly what you need.",
    founderQuote: "You feel my dedication in every recommendation, every ritual — and in every moment when you feel seen, understood and empowered.",
    founderName: "Annam Hanfstein",
    founderRole: "Founder & CEO — AYU-rveda",
    chatBadge: "This is what AYU looks like",
    chatTitle1: "Your personal",
    chatTitle2: "health companion",
    chatDesc: "AYU knows your phenotype and gives you answers that truly fit you — every day, at your pace.",
    chatSubtitle: "Your AYU — always there for you",
    chatFeature1Title: "Personalized answers",
    chatFeature1Text: "Based on your phenotype you receive recommendations that truly fit you — no generic tips.",
    chatFeature2Title: "Nutrition & routines",
    chatFeature2Text: "Ask about meals, morning routines or evening rituals — AYU knows your type and your needs.",
    chatFeature3Title: "Health journal",
    chatFeature3Text: "Track how you feel. Over time, AYU recognizes patterns and helps you find your balance.",
    chatFeature4Title: "24/7 available",
    chatFeature4Text: "Your personal health companion is always there — in the morning at breakfast or in the evening before bed.",
    chatCompanion: "Your health companion",
    chatMsg1Date: "Wednesday, March 5",
    chatMsg1User: "I've been feeling bloated for days and have barely any energy. What can I do?",
    chatMsg1Bot: "Good morning! Based on your phenotype I recommend warm, grounding foods today. Start the day with a warm oat or rice porridge, refined with spices like turmeric and ginger.",
    chatMsg2User: "What should I eat for lunch?",
    chatMsg2Bot: "Incorporate steamed vegetables (like root vegetables) and light soups. Avoid raw food and cold drinks. Your lunch should be the largest meal of the day.",
    chatMsg3User: "And what about exercise?",
    chatMsg3Bot: "Your morning routine should include gentle movements and a glass of warm water with lemon. Try 15 minutes of pranayama (breathing exercises) and a short walk after lunch. Stay healthy!",
    chatInputPlaceholder: "Ask me something...",
    readyTitle1: "Ready to understand",
    readyTitle2: "your body?",
    readyDesc: "In this brief introduction you will discover how AYU supports holistic health in a personalized and practical way.",
    readyTag1: "Approx. 10 minutes",
    readyTag2: "Free",
    readyTag3: "No diagnosis",
    nextTitle: "Ready for the next step?",
    nextDesc: "Start your personal AYU Journey now — free and without obligation.",
    nextCardTitle: "Start your AYU Journey",
    nextCardDesc: "Get instant access to your personalized health plan — based on 5,000 years of Ayurveda wisdom and your unique constitution.",
    nextContact: "Write to us anytime.",
    footerStartseite: "Homepage",
    footerImpressum: "Imprint",
    footerDatenschutz: "Privacy",
    inlineCta1Text: "Ready to understand your body?",
    inlineCta1Button: "Start for free now",
    inlineCta2Text: "Your plan in just 3 steps",
    inlineCta2Button: "Start assessment",
    inlineCta3Text: "Find your way to more balance",
    inlineCta3Button: "Discover now",
    inlineCta4Text: "Over 180,000 people trust AYU",
    inlineCta4Button: "Start for free",
  },

  buch: {
    navConsultation: "Book consultation",
    navBuy: "Buy now",
    heroBadge: "The book by Annam & Christopher",
    heroStarRating: "Reader ratings",
    heroFormatLabel: "Format",
    heroEbookTitle: "E-Book (PDF)",
    heroEbookSub: "Instant download",
    heroPrintTitle: "Print book",
    heroPrintSub: "Delivered to your home",
    heroVatNote: "incl. VAT",
    heroBuyButton: "Buy now",
    heroBadgePayment: "Secure payment via Stripe",
    heroBadgeDownload: "Instant download",
    heroBadgeShipping: "Shipping in 3-5 days",
    beschreibungBadge: "Why this book?",
    beschreibungTitle1: "Why the Alps are not Kerala",
    beschreibungTitle2: "Ayurveda rethought",
    beschreibungP1: "Ayurveda does not mean blindly following an endless list of recipes and tips. It means understanding people in the context of their environment — with place, time and constitution as decisive factors.",
    beschreibungP2: "But Europe, North America and Australia are not India. Different climate, nutrition, culture and genetics change how recommendations work — what heals there can burden here.",
    beschreibungP3: "The AYU approach translates these differences into twelve functional human types. They are not a question of origin, but of reaction and pattern. Every person — whether in Hamburg, New York, Toronto or Sydney — finds themselves in them.",
    beschreibungP4: "The result: an Ayurveda that truly works. Tailored, preventive and practical. A key to genuine health in the 21st century.",
    kapitelBadge: "What awaits you",
    kapitelTitle1: "The core topics of the",
    kapitelTitle2: "book",
    kapitel1Title: "Why the Alps are not Kerala",
    kapitel1Desc: "Ayurveda rethought in the western context",
    kapitel2Title: "12 functional human types",
    kapitel2Desc: "Not a question of origin, but of reaction and pattern",
    kapitel3Title: "Climate, culture & genetics",
    kapitel3Desc: "How environmental factors change recommendations",
    kapitel4Title: "Ayurveda that truly works",
    kapitel4Desc: "Tailored, preventive and practical",
    autorenBadge: "The authors",
    autorenTitle: "Hanfstein",
    autorenAnnam: "inspires over 180,000 people with Ayurveda. Coming from a healing dynasty, she lives the knowledge that has accompanied her since childhood — practical, everyday and full of vitality.",
    autorenChristopher: "is a health strategist and founder of GENOpuzzle.com. With deep experience in the healthcare system he connects ancient wisdom with modern technology to rethink prevention.",
    autorenTogether: "Together they bring Ayurveda into a new era — as a symbiosis of tradition and innovation, accessible to all.",
    reviewsBadge: "Reader voices",
    reviewsTitle1: "What our",
    reviewsTitle2: "readers say",
    review1Text: "This book completely changed my perspective on Ayurveda. Finally an approach that works in Europe.",
    review2Text: "Scientifically sound yet understandable. A must for anyone interested in holistic health.",
    review3Text: "Annam and Christopher connect ancient knowledge with modern science in a unique way.",
    kaufenBadge: "Order now",
    kaufenTitle: "Your copy of",
    kaufenDesc: "Available as an e-book (PDF) for instant download or as a high-quality print book — in German and English.",
    ebookTitle: "E-Book (PDF)",
    ebookSub: "Instant download after purchase",
    ebookFeature1: "Instant download as PDF",
    ebookFeature2: "Readable on all devices",
    ebookFeature3: "German & English available",
    ebookFeature4: "Printable for personal use",
    ebookLangDe: "Deutsch",
    ebookLangEn: "English",
    ebookBuyButton: "Buy e-book",
    printTitle: "Print book",
    printSub: "Delivered to your home",
    printFeature1: "High-quality print",
    printFeature2: "Shipping in 3-5 working days",
    printFeature3: "Perfect as a gift",
    printFeature4: "German (print edition)",
    printBuyButton: "Order print book",
    trustPayment: "Secure payment via Stripe",
    trustDownload: "Instant download after purchase",
    trustGlobal: "Available worldwide",
    finalTitle1: "Ready for an Ayurveda that",
    finalTitle2: "truly works",
    finalDesc: "Discover why traditional Ayurveda must be adapted in Europe — and how the AYU approach shows you the path to genuine health.",
    finalBuyButton: "Order book now",
    finalConsultButton: "Free consultation",
    footerCopyright: "All rights reserved.",
    footerHome: "Homepage",
    footerConsultation: "Consultation",
    footerOffer: "Offer",
  },
} as const;

export default en;
